<template>
<div class="main" id="detail-4473">

    <transition name="fade">
        <div class="modal" v-if="showSavingForm">
            <div class="inner modal-message" :class="{ done: !savingForm }">
                <h2>{{ savingForm ? 'Saving...' : saveError ? 'Error' : 'Done' }}</h2>
                <loading v-if="savingForm">Saving...</loading>
                <div v-else-if="showSavingForm">
                    <div class="modal-icon">
                        <i v-if="saveError" class="fas fa-exclamation"></i>
                        <i v-else class="fas fa-check"></i>
                    </div>
                    <p v-if="formSaveMessage" v-html="formSaveMessage"></p>
                </div>
                <div class="controls control-buttons modal-message-controls">
                    <div class="button cancel" @click="showSavingForm = false">Dismiss</div>
                </div>
            </div>
        </div>
    </transition>
    <div class="save-contact" v-if="!form.contact_id">
        <h2>New Form 4473</h2>
        <template v-if="!creatingContact">
            <p>Start a new Form 4473 by searching your contacts to find the Transferee/Buyer information...</p>
            <div class="three-one-columns">
                <div class="input-with-control">
                    <input type="text" v-model="search_customers" placeholder="Search contacts..." @keyup.enter="searchContacts">
                    <div class="button action input-go" @click="searchContacts"><i class="fas fa-search"></i></div>
                </div>
                <button class="button action" @click="creatingContact = true">New</button>
            </div>
            <div class="search-result bordered">
                <ul v-if="customers && customers.length != 0" class="search-list">
                    <li class="clickable-list-item" v-for="(customer, index) in customers" @click="assignCustomer(customer)" :key="index">
                        <span>{{ customer.full_name || $fullName(customer) }}</span>
                        <span v-if="customer.address_1">{{ customer.address_1 }}</span>
                        <span v-if="customer.city">{{ customer.city }}, {{ customer.state }} {{ customer.zip_code }}</span>
                        <span v-if="customer.ffl_number">{{ customer.ffl_number }}</span>
                    </li>
                </ul>
                <div v-else-if="customerSearchMessage" class="no-results">{{ customerSearchMessage }}</div>
            </div>
        </template>
        <div class="create-contact" v-else>
            <h3>Create New Contact</h3>
            <div class="two-columns">
                <label for="first_name">First Name
                    <input name="new_first_name" type="text" v-model="newContact.first_name">
                </label>
                <label for="first_name">Middle Name
                    <input name="new_middle_name" type="text" v-model="newContact.middle_name">
                </label>
                <label for="last_name">Last Name
                    <input name="new_last_name" type="text" v-model="newContact.last_name">
                </label>
                <label for="last_name">Suffix
                    <input name="new_suffix" type="text" v-model="newContact.suffix">
                </label>
            </div>
            <button class="button cancel spaced" @click="creatingContact = false">Return to Search</button>
            <button class="button primary" @click="createContact()">Continue</button>
            <div class="message">{{ newContactMessage }}</div>
        </div>
        <router-link to="/logbooks/4473" tag="div" class="primary button" style="margin: 1em 0 0 0;"><i class="fa fa-arrow-circle-left"></i> Back To List</router-link>
    </div>

    <div class="main-form-container detail-4473-inner list-view" v-else-if="form.form_data && !nicsOnlineCheck">
        <div class="controls form-controls filters">
            <div class="form-customer">
                <div class="smaller">Transferee/Buyer:</div>
                <div class="customer-name">{{ contact_data.full_name || contact_data.first_name + ' ' + contact_data.middle_name + ' ' + contact_data.last_name + ' ' + contact_data.suffix }}</div>
                <div class="smaller">{{ contact_data.address_1 }}<br>
                {{ contact_data.city + ' ' + contact_data.state + ' ' + contact_data.zip_code }}</div>
            </div>
            <ul class="section-list" v-if="!correctingForm">
                <li class="pointer" @click="showSection('section_a')"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('A')}"></i> Section A <span class="section-owner">Employee</span></li>
                <li class="disabled" v-if="!statusCodes.A_COMPLETE || (correctingForm && formSection != 'section_b')"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('B')}"></i> <span :class="{error: sectionBAlert}">Section B</span> <span class="section-owner"><span v-if="sectionBAlert" class="error">Needs Review</span><span v-else>Customer</span></span></li>
                <li class="pointer" v-else-if="userCanEdit && !statusCodes.B_COMPLETE"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('B')}"></i><a :href="'/dashboard/logbooks/customer-4473?section=b&id=' + id" target="_blank"> <span :class="{error: sectionBAlert}">Section B</span> <span class="section-owner"><span v-if="sectionBAlert" class="error">Needs Review</span><span v-else>Customer</span></span></a></li>
                <li class="pointer" v-else @click="showSection('section_b')"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('B')}"></i> <span :class="{error: sectionBAlert}">Section B</span> <span class="section-owner"><span v-if="sectionBAlert" class="error">Needs Review</span><span v-else>Customer</span></span></li>
                <template v-if="!statusCodes.B_COMPLETE">
                    <li class="disabled"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('C')}"></i> Section C <span class="section-owner">Employee</span></li>
                    <li class="disabled"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('D')}"></i> Section D <span class="section-owner">Customer</span></li>
                    <li class="disabled"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('E')}"></i> Section E <span class="section-owner">Employee</span></li>
                </template>
                <template v-else>
                    <li class="pointer" @click="showSection('section_c')"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('C')}"></i> Section C <span class="section-owner">Employee</span></li>
                    <li class="pointer"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('D')}"></i>
                        <span v-if="!userCanEdit || statusCodes.D_COMPLETE || statusCodes.E_COMPLETE" @click="showSection('section_d')"><span> Section D</span> <span class="section-owner">Customer</span></span>
                        <span v-else><a :href="'/dashboard/logbooks/customer-4473?section=d&id=' + id" target="_blank"> Section D <span class="section-owner">Customer</span></a></span>
                    </li>
                    <li class="pointer" @click="showSection('section_e')"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('E')}"></i> Section E <span class="section-owner">Employee</span></li>
                </template>
            </ul>
            <!-- We're moving the form so if Section E isn't complete, no need for the user to click on Sections C, D or E -->
            <ul class="section-list" v-else>
                <li class="disabled" v-if="correctingForm && formSection != 'section_a'"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('A')}"></i> Section A <span class="section-owner">Employee</span></li>
                <li class="pointer" @click="formSection = 'section_a'" v-else><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('A')}"></i> Section A <span class="section-owner">Employee</span></li>
                <li class="disabled" v-if="correctingForm && formSection != 'section_b'"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('B')}"></i> Section B <span class="section-owner">Customer</span></li>
                <li class="pointer" @click="formSection = 'section_b'" v-else><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('B')}"></i> Section B <span class="section-owner">Customer</span></li>
                <template v-if="!formCopy.status_codes.E_COMPLETE">
                    <li class="disabled"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('C')}"></i> Section C <span class="section-owner">Employee</span></li>
                    <li class="disabled"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('D')}"></i> Section D <span class="section-owner">Customer</span></li>
                    <li class="disabled"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('E')}"></i> Section E <span class="section-owner">Employee</span></li>
                </template>
                <template v-else>
                    <li class="disabled" v-if="correctingForm && formSection != 'section_c'"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('C')}"></i> Section C <span class="section-owner">Employee</span></li>
                    <li class="pointer" @click="formSection = 'section_c'" v-else><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('C')}"></i> Section C <span class="section-owner">Employee</span></li>
                    <li class="disabled" v-if="correctingForm && formSection != 'section_d'"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('D')}"></i> Section D <span class="section-owner">Customer</span></li>
                    <li class="pointer" @click="formSection = 'section_d'" v-else><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('D')}"></i> Section D <span class="section-owner">Customer</span></li>
                    <li class="disabled" v-if="correctingForm && formSection != 'section_e'"><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('E')}"></i> Section E <span class="section-owner">Employee</span></li>
                    <li class="pointer" @click="formSection = 'section_e'" v-else><i class="fas fa-check-circle" :class="{section_complete: sectionComplete('E')}"></i> Section E <span class="section-owner">Employee</span></li>
                </template>
            </ul>

            <div v-if="userCanEdit" :class="['button', canSaveSection ? 'primary' : 'disabled']" @click="saveForm()">Save 4473</div>

            <div v-if="userCanEdit" class="button neutral" @click="cancellingForm = true">{{ form.inactive ? 'Reactivate' : 'Cancel' }} 4473</div>

            <router-link to="/logbooks/4473" tag="div" class="neutral button">Back To List</router-link>

            <div class="divider"></div>

            <div class="button neutral" @click="filesUploadModalOpen = true">Attachments</div>

            <div v-if="!newForm && clientHasVariance" class="neutral button" @click="generatePDF()">Export PDF</div>
            <a v-if="!newForm" class="button neutral" :href="generatePDFLink()" target="_blank">Print</a>

            <router-link v-if="userCanEdit && statusCodes.E_COMPLETE" :to="'/logbooks/dispose?form=' + form.ffl_log_book_form_id" tag="div" class="primary button">Dispose This Form</router-link>

            <div class="divider" v-if="enableCorrection && (sectionLetter != 'A' || (sectionLetter == 'A' && statusCodes.E_COMPLETE))"></div>
            <button class="button neutral" @click="copyForm()" v-if="enableCorrection && userCanEdit && (sectionLetter != 'A' || (sectionLetter == 'A' && statusCodes.E_COMPLETE))">Correct Section {{ sectionLetter }}</button>
            <router-link :to="'/logbooks/4473/' + movedFromFFLLogBookFormId" class="grey button" v-if="enableCorrection && movedFromFFLLogBookFormId">Previous Version</router-link>

            <div v-if="correctingForm" class="authorize-correctionz">
                <h3>Correcting Section {{ sectionLetter }}</h3>
                <label for="authorized_initials">Initial here:</label>
                <input type="text" name="authorized_initials" v-model="userInitials">
                <div class="warning small" v-if="userInitials.length < 2">Your initials are required to save the correction.</div>
                <div :class="['button', userInitials ? 'primary' : 'disabled']" @click="validateFormCorrect()">Save Correction</div>
                <div class="button cancel" @click="revertForm" v-if="correctingForm">Cancel Correction</div>
            </div>

            <!-- <div v-if="clientHasVariance && form.internal_use_only">
                <div class="divider"></div>
                <div class="button cancel" @click="markFormForCorrection()">Cancel Pending Customer Correction</div>
            </div> -->

        </div>

        <div class="save-transaction-serial-number">
            <div v-if="userCanEdit" class="note">{{ formNumberMessage }}</div>
            <input type="text" v-model="form.form_number" placeholder="Transaction SN">
            <div v-if="userCanEdit" class="button primary" style="margin-top: 0;" @click="saveFormNumber()"><i class="fas fa-check"></i></div>
            <div class="link" @click="bookmarkForm()"><i :class="[form.bookmarked ? 'fas' : 'far', 'fa-bookmark']"></i></div>
        </div>

        <div class="form section-a list dealer-form" v-if="!loading && formSection == 'section_a'" ref="section_top">

            <div class="help-box-outer form-line">
                <div :class="['help-box-label', showHelp.indexOf(0) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(0)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(0) > -1">
                    <p>NOTICES, INSTRUCTIONS, AND DEFINITIONS</p>
                    <p>Purpose of the Form: The information and certification on this form are designed so that a person licensed under 18 U.S.C. 923 may determine if he/she may lawfully sell or deliver a firearm to the person identified in Section B, and to alert the transferee/buyer of certain restrictions on the receipt and possession of firearms. The transferor/seller of a firearm must determine the lawfulness of the transaction and maintain proper records of the transaction. Consequently, the transferor/seller must be familiar with the provisions of 18 U.S.C. 921-931 and the regulations in 27 CFR Parts 478 and 479. In determining the lawfulness of the sale or delivery of a rifle or shotgun to a resident of another State, the transferor/seller is presumed to know the applicable State laws and published ordinances in both the transferor’s/seller’s State and the transferee’s/buyer’s State. (See State Laws and Published Ordinances -Firearms (ATF Electronic Publication 5300.5) on https://www.atf.gov/.)</p>

                    <p>Generally, ATF Form 4473 must be completed at the licensed business premises when a firearm is transferred over-the-counter. Federal law, 18 U.S.C. 922(c), allows a licensed importer, manufacturer, or dealer to sell a firearm to a nonlicensee who does not appear in person at the licensee’s business premises only if the transferee/ buyer meets certain requirements. These requirements are set forth in section 922(c), 27 CFR 478.96(b), and ATF Procedure 2013-2 (or subsequent update).</p>

                    <p>After the transferor/seller has completed the firearms transaction, he/she must make the completed, original ATF Form 4473 (which includes the Notices, General Instructions, and Definitions), and any supporting documents, part of his/her permanent records. Such Forms 4473 must be retained for at least 20 years and after that period may be submitted to ATF. Filing may be chronological (by date of disposition), alphabetical (by name of purchaser), or numerical (by transaction serial number), as long as all of the transferor’s/seller’s completed Forms 4473 are filed in the same manner.</p>

                    <p><strong>FORMS 4473 FOR DENIED/CANCELLED TRANSFERS MUST BE RETAINED:</strong> If the transfer of a firearm is denied/cancelled by NICS, or if for any other reason the transfer is not completed after a NICS check is initiated, the licensee must retain the ATF Form 4473 in his/her records for at least 5 years. Forms 4473 with respect to which a sale, delivery, or transfer did not take place shall be separately retained in alphabetical (by name of transferee) or chronological (by date of transferee’s certification) order.</p>

                    <p>If the transferor/seller or the transferee/buyer discovers that an ATF Form 4473 is incomplete or improperly completed after the firearm has been transferred, and the transferor/seller or the transferee/buyer wishes to correct the omission(s) or error(s), photocopy the inaccurate form and make any necessary additions or revisions to the photocopy. The transferor/seller should only make changes to Sections A, C, and E. The transferee/buyer should only make changes to Sections B and D. Whoever made the changes should initial and date the changes. The corrected photocopy should be attached to the original Form 4473 and retained as part of the transferor’s/seller’s permanent records.</p>
                </div>
            </div>

            <h2 class="section-title" sytle="margin: 0;">Section A - Must Be Completed By Transferor/Seller Before Transferee/Buyer Completes Section B</h2>

            <div class="firearms form-line" style="width: 99%;">
                <changes :changeLog="changeLog.firearms_list" v-if="changeLog.firearms_list">
                    <div class="log-time">{{ changeLog.firearms_list.log_time }}</div>
                    <ul class="old-value" style="min-width: 500px;">
                        <li class="firearms-list">
                            <span>Manufacturer</span>
                            <span>Model</span>
                            <span>Serial Number</span>
                            <span>Type</span>
                            <span>Caliber</span>
                        </li>
                        <li class="firearms-list" v-for="(firearm, index) in changeLog.firearms_list.old_value">
                            <span>{{ firearm.manufacturer }}</span>
                            <span>{{ firearm.model }}</span>
                            <span>{{ firearm.serial_number }}</span>
                            <span>{{ firearm.gun_type }}</span>
                            <span>{{ firearm.caliber }}</span>
                        </li>
                    </ul>
                </changes>
                <div class="firearms-list header">
                    <div class="cell form-header">1.<div class="note">Manufacturer and Importer (If any) (If the manufacturer and importer are different, the FFL must include both.)</div></div>
                    <div class="cell form-header">2.<div class="note">Model<br>(If Designated)</div></div>
                    <div class="cell form-header">3.<div class="note">Serial Number</div></div>
                    <div class="cell form-header">4.<div class="note">Type</div></div>
                    <div class="cell form-header">5.<div class="note">Caliber or Gauge</div></div>
                    <div></div>
                </div>
                <div class="firearms-list" v-for="(firearm, index) in form.form_data.section_a.firearms_list" :key="index" :class="{ incomplete: firearmsIncomplete.includes(index) }">
                    <div class="cell"><label class="inline-block">{{ index + 1 }}.</label><input :disabled="statusCodes.E_COMPLETE" type="text" v-model="firearm.manufacturer" @keyup="checkFirearmsList(index)"></div>
                    <div class="cell"><input :disabled="statusCodes.E_COMPLETE" type="text" v-model="firearm.model" @keyup="checkFirearmsList(index)"></div>
                    <div class="cell">
                        <input v-if="!userCanEdit" type="text" v-model="firearm.serial_number">
                        <input v-else :disabled="statusCodes.E_COMPLETE" type="text" v-model="firearm.serial_number" @keyup="checkFirearmsList(index)" @keyup.enter="serialSearch(index, firearm.serial_number)">
                        <i v-if="userCanEdit && !statusCodes.E_COMPLETE" class="fas fa-search" @click="serialSearch(index, firearm.serial_number)"></i>
                    </div>
                    <div class="cell"><input :disabled="statusCodes.E_COMPLETE" type="text" v-model="firearm.gun_type" @keyup="checkFirearmsList(index)"></div>
                    <div class="cell"><input :disabled="statusCodes.E_COMPLETE" type="text" v-model="firearm.caliber" @keyup="checkFirearmsList(index)">
                        <div class="loading" v-if="firearmSearchResults.length == 0 && serialNumberLookup == index"><i class="far fa-compass fa-spin"></i></div>
                        <div class="firearm-lookup-message" v-if="firearmMessageIndex == index">{{ firearmMessage }}</div>
                        <div class="firearm-lookup-message" v-if="firearmSearchResults.length > 0 && serialNumberLookup == index">
                            <ul class="search-list" style="float: left; margin-left: calc(50vw - 22em);">
                                <li class="clickable-list-item" v-for="(firearm, subindex) in firearmSearchResults" @click="assignFirearmsList(index,firearm)">
                                    <span>Sequence: <b>{{ firearm.ffl_log_book_code }}-{{ firearm.sequence_number }}</b></span>
                                    <span>{{ firearm.manufacturer }} {{ firearm.model }}</span>
                                    <span>Serial Number: <b>{{ firearm.serial_number }}</b></span>
                                    <span>{{ firearm.gun_type }} {{ firearm.caliber }}</span>
                                </li>
                            </ul>
                            <button class="button action search-list-cancel" style="font-size: 0.7em; float: left;" @click="cancelSerialNumberSearchResults()">X</button>
                        </div>
                    </div>
                    <div class="remove-firearm" @click="removeFirearm(index)" v-if="userCanEdit && !isBlank(firearm) && !statusCodes.E_COMPLETE"><i class="fas fa-times"></i></div>
                </div>
            </div>
            <!-- /.firearms -->
            <div class="help-box-outer form-line">
                <div :class="['help-box-label', showHelp.indexOf(1) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(1)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(1) > -1">
                    <p><strong>Questions 1-6. Firearm(s) Description:</strong> These blocks must be completed with the firearm(s) information. All firearms manufactured after 1968 by Federal firearms licensees should be marked with a serial number. Should you acquire a firearm that is legally not marked with a serial number (i.e. pre-1968); you may answer question 3 with "NSN" (No Serial Number), "N/A" or "None."</p>

                    <p>If more than three firearms are involved in a transaction, please provide the information required by Section A, Questions 1-5, on ATF Form 5300.9A, Firearms Transaction Record Continuation Sheet. The completed Form 5300.9A must be attached to this ATF Form 4473.</p>

                    <p>Types of firearms include, but are not limited to: pistol, revolver, rifle, shotgun, receiver, frame, and firearms that are neither handguns nor long guns (rifles or shotguns), such as firearms having a pistol grip that expel a shotgun shell (pistol grip firearm) or NFA firearms (machinegun, silencer, short-barreled shotgun, short-barreled rifle, destructive device, or "any other weapon").</p>

                    <p>Additional firearms purchases by the same transferee/buyer may not be added to the form after the transferor/seller has signed and dated it. A transferee/buyer who wishes to acquire additional firearms after the transferor/seller has signed and dated the form must complete a new ATF Form 4473 and undergo a new NICS check.</p>
                </div>
            </div>

            <div class="form-line two-columns">
                <div>
                    <div class="label">6. Total Number of Firearms Transferred (Please handwrite by printing e.g., zero, one, two, three, etc. Do not use numerals.)
                    <changes :changeLog="changeLog['section_a.total_firearms_transferred']" v-if="changeLog['section_a.total_firearms_transferred']"></changes></div>
                    <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_a.total_firearms_transferred" readonly>
                </div>
                <div>
                    <div class="three-one-columns">
                        <div class="label">7. Check if any part of this transaction is a pawn redemption.
                            <changes :changeLog="changeLog['section_a.transaction_pawn_redemption']" v-if="changeLog['section_a.transaction_pawn_redemption']"></changes>
                        </div>
                        <label class="checkbox with-outside-label">
                            <input type="checkbox" :disabled="statusCodes.E_COMPLETE" v-model="form.form_data.section_a.transaction_pawn_redemption">
                            <span :class="{disabled: statusCodes.E_COMPLETE}"><i class="fas fa-check-circle"></i></span>
                        </label>
                    </div>
                    <div class="three-one-columns">
                        <label style="text-align: right; padding: 0.5em 0 0 0;">Record Line Number(s) From Question 1 Above:
                            <changes :changeLog="changeLog['section_a.transaction_pawn_redemption_line_numbers']" v-if="changeLog['section_a.transaction_pawn_redemption_line_numbers']"></changes>
                        </label>
                        <input :class="{ disabled: form.form_data.section_a.transaction_pawn_redemption == false }" :disabled="(form.form_data.section_a.transaction_pawn_redemption == false) || statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_a.transaction_pawn_redemption_line_numbers">
                    </div>
                </div>
                <div class="three-one-columns">
                    <div class="label">8. Check if this transaction is to facilitate a private party transfer.
                        <changes :changeLog="changeLog['section_a.private_party_transfer']" v-if="changeLog['section_a.private_party_transfer']"></changes>
                    </div>
                    <label class="checkbox with-outside-label">
                        <input type="checkbox" :disabled="statusCodes.E_COMPLETE" v-model="form.form_data.section_a.private_party_transfer">
                        <span :class="{disabled: statusCodes.E_COMPLETE}"><i class="fas fa-check-circle"></i></span>
                    </label>
                </div>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(8) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(8)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(8) > -1">
                    Question 8. Private Party Transfer: Check this box if the licensee is facilitating the sale or transfer of a firearm between private unlicensed individuals in accordance with ATF Procedure 2017-1. This will assist the licensee by documenting which transaction records correspond with private party transfers, and why there may be no corresponding A&amp;D entries when the transfer did not proceed because it was denied, delayed, or cancelled.
                </div>
            </div>
        </div>

        <div class="form section-b list dealer-form" v-if="formSection == 'section_b'" ref="section_top">
            <h2 class="section-title">Section B - Must Be Completed Personally By Transferee/Buyer</h2>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('B') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('B')"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf('B') > -1">
                    <p>Section B</p>

                    <p>The transferee/buyer must personally complete Section B of this form and certify (sign and date) that the answers are true, correct, and complete. However, if the transferee/buyer is unable to read and/or write, the answers (other than the signature) may be completed by another person, excluding the transferor/seller. Two persons (other than the transferor/seller) must then sign as witnesses to the transferee’s/ buyer’s answers and signature/certification in question 22.</p>

                    <p>When the transferee/buyer of a firearm is a corporation, company, association, partnership, or other such business entity, an officer authorized to act on behalf of the business must complete Section B of the form with his/her personal information, sign Section B, and attach a written statement, executed under penalties of perjury, stating: (A) the firearm is being acquired for the use of and will be the property of that business entity; and (B) the name and address of that business entity.</p>
                </div>
            </div>

            <div class="form-line label">9. Transferee’s/Buyer’s Full Name (If legal name contains an initial only, record the initial followed by “IO” in quotes. If no middle initial or name, record “NMN”.)</div>

            <div class="form-line two-columns">
                <div class="three-two-columns">
                    <label id="last_name" class="span-three" for="last_name">
                        Last Name (including suffix, e.g., Jr, Sr, II, III)
                        <changes :changeLog="changeLog['section_b.last_name']" v-if="changeLog['section_b.last_name'] || changeLog['section_b.last_initial'] || changeLog['section_b.suffix']">
                            <div class="log-time">{{ changeLog.log_time }}</div>
                            <div class="old-value" v-if="changeLog['section_b.last_name']">{{ changeLog['section_b.last_name'].old_value }}</div>
                            <div class="old-value" v-if="changeLog['section_b.suffix']">{{ changeLog['section_b.suffix'].old_value }}</div>
                            <div class="old-value" v-if="changeLog['section_b.last_initial']">Initial Only: {{ (changeLog['section_b.last_initial'].old_value == '' || changeLog['section_b.last_initial'].old_value === 0) ? 'false' : 'true' }}</div>
                        </changes>
                    </label>
                    <input :disabled="statusCodes.B_COMPLETE" name="last_name" type="text" v-model="form.form_data.section_b.last_name" ref="last_name">
                    <select :disabled="statusCodes.B_COMPLETE" name="suffix" id="suffix" v-model="form.form_data.section_b.suffix">
                        <option v-for="(code, value) in getEnicsCadenceCodes" :value="code">{{ value }}</option>
						<option value="II" title="">II</option>
						<option value="III" title="">III</option>
						<option value="IV" title="">IV</option>
						<option value="V" title="">V</option>
						<option value="VI" title="">VI</option>
						<option value="VII" title="">VII</option>
						<option value="VIII" title="">VIII</option>
						<option value="IX" title="">IX</option>
						<option value="X" title="">X</option>
						<option value="JR" title="">Jr</option>
						<option value="SR" title="">Sr</option>
					</select>
                    <label class="checkbox" id="last_initial">
                        <input :disabled="statusCodes.B_COMPLETE" type="checkbox" class="half-input" v-model="form.form_data.section_b.last_initial">
                        <span :class="{disabled: statusCodes.B_COMPLETE}">
                            <i class="fas fa-check-circle"></i>
                            IO
                        </span>
                    </label>
                </div>
                <div class="three-one-columns">
                    <label id="first_name" class="span-two" for="first_name">
                        First Name
                        <changes :changeLog="changeLog['section_b.first_name']" v-if="changeLog['section_b.first_name'] || changeLog['section_b.first_initial']">
                            <div class="log-time">{{ changeLog.log_time }}</div>
                            <div class="old-value" v-if="changeLog['section_b.first_name']">{{ changeLog['section_b.first_name'].old_value }}</div>
                            <div class="old-value" v-if="changeLog['section_b.first_initial']">Initial Only: {{ (changeLog['section_b.first_initial'].old_value == '' || changeLog['section_b.first_initial'].old_value === 0) ? 'false' : 'true' }}</div>
                        </changes>
                    </label>
                    <input :disabled="statusCodes.B_COMPLETE" name="first_name" type="text" v-model="form.form_data.section_b.first_name" ref="first_name">
                    <label class="checkbox" id="first_initial">
                        <input :disabled="statusCodes.B_COMPLETE" type="checkbox" class="half-input" v-model="form.form_data.section_b.first_initial">
                        <span :class="{disabled: statusCodes.B_COMPLETE}">
                            <i class="fas fa-check-circle"></i>
                            IO
                        </span>
                    </label>
                </div>
            </div>

            <div class="three-one-columns" style="width: 64%; grid-template-columns: 1fr 0.8fr;">
                <label id="middle_name" class="span-two" for="middle_name">
                    Middle Name
                    <changes :changeLog="changeLog['section_b.middle_name']" v-if="changeLog['section_b.middle_name'] || changeLog['section_b.middle_initial']">
                        <div class="log-time">{{ changeLog.log_time }}</div>
                        <div class="old-value" v-if="changeLog['section_b.middle_name']">{{ changeLog['section_b.middle_name'].old_value }}</div>
                        <div class="old-value" v-if="changeLog['section_b.middle_initial']">Initial Only: {{ (changeLog['section_b.middle_initial'].old_value == '' || changeLog['section_b.middle_initial'].old_value === 0) ? 'false' : 'true' }}</div>
                        <div class="old-value" v-if="changeLog['section_b.no_middle_name']">No Middle Name: {{ (changeLog['section_b.no_middle_name'].old_value == '' || changeLog['section_b.no_middle_name'].old_value === 0) ? 'false' : 'true' }}</div>
                    </changes>
                </label>
                <input :disabled="statusCodes.B_COMPLETE" name="middle_name" type="text" v-model="form.form_data.section_b.middle_name">
                <div>
                    <label class="checkbox" id="middle_initial">
                        <input :disabled="statusCodes.B_COMPLETE" type="checkbox" class="half-input" v-model="form.form_data.section_b.middle_initial">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>IO</span>
                    </label>
                    <label class="checkbox" id="no_middle_name">
                        <input :disabled="statusCodes.B_COMPLETE" type="checkbox" class="half-input" v-model="form.form_data.section_b.no_middle_name">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>NMN</span>
                    </label>
                </div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(9) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(9)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(9) > -1">
                    <strong>Question 9.</strong> Transferee's/Buyers Full Name: If the transferee's/buyer's name is illegible, the transferor/seller must print the transferee's/buyer's name above the name written by the transferee/buyer.
                </div>
            </div>

            <div class="form-line label">10. Current State of Residence and Address (U.S. postal abbreviations are acceptable. Cannot be a post office box.)</div>
            <div class="form-line five-columns address">
                <div class="address-1">
                    <label id="address_1">
                        Number and Street Address
                        <changes :changeLog="changeLog['section_b.address_1']" v-if="changeLog['section_b.address_1']"></changes>
                    </label>
                    <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.address_1" ref="address_1">
                </div>

                <div class="city">
                    <label id="city">
                        City
                        <changes :changeLog="changeLog['section_b.city']" v-if="changeLog['section_b.city']"></changes>
                    </label>
                    <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.city" ref="city">
                </div>

                <div class="state">
                    <label id="state">
                        State
                        <changes :changeLog="changeLog['section_b.state']" v-if="changeLog['section_b.state']"></changes>
                    </label>
                    <select :disabled="statusCodes.B_COMPLETE" v-model="form.form_data.section_b.state" ref="state">
                        <option :value="null">State...</option>
                        <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
                        <!-- <option v-for="(state, abbr) in getEnicsStateOfResidenceCodes" :value="abbr">{{ state }}</option> -->
                    </select>
                </div>

                <div class="zip-code">
                    <label id="zip_code">
                        Zip Code
                        <changes :changeLog="changeLog['section_b.zip_code']" v-if="changeLog['section_b.zip_code']"></changes>
                    </label>
                    <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.zip_code" ref="zip_code">
                </div>

                <div class="county">
                    <label id="county">
                        County/Parish/Borough
                        <changes :changeLog="changeLog['section_b.county']" v-if="changeLog['section_b.county']"></changes>
                    </label>
                    <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.county" ref="county">
                </div>
            </div>

            <div class="form-line">
                <label class="checkbox with-outside-label">
					<input :disabled="statusCodes.B_COMPLETE && !newForm" type="checkbox" id="nics_buyer_background_check" v-model="extraAddress">
					<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i></span>
                    <span class="label-text">Are you a service member who is acquiring a firearm in a State where your permanent duty station is located, but reside in a different State?</span>
				</label>
            </div>

            <template v-if="extraAddress">
                <div class="form-line">Home State and Address (U.S.Postal abbreviations are acceptable. Cannot be a post office box.)</div>
                <div class="form-line five-columns address">
                    <div class="home-address-1">
                        <label id="home_address_1">
                            Number and Street Address
                            <changes :changeLog="changeLog['section_b.home_address_1']" v-if="changeLog['section_b.home_address_1']"></changes>
                        </label>
                        <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.home_address_1" ref="address_1">
                    </div>

                    <div class="home-city">
                        <label id="home_city">
                            City
                            <changes :changeLog="changeLog['section_b.home_city']" v-if="changeLog['section_b.home_city']"></changes>
                        </label>
                        <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.home_city" ref="city">
                    </div>

                    <div class="home-state">
                        <label id="home_state">
                            State
                            <changes :changeLog="changeLog['section_b.home_state']" v-if="changeLog['section_b.home_state']"></changes>
                        </label>
                        <select :disabled="statusCodes.B_COMPLETE" v-model="form.form_data.section_b.home_state" ref="state">
                            <option :value="null">State...</option>
                            <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
                        </select>
                    </div>

                    <div class="home-zip-code">
                        <label id="home_zip_code">
                            Zip Code
                            <changes :changeLog="changeLog['section_b.home_zip_code']" v-if="changeLog['section_b.home_zip_code']"></changes>
                        </label>
                        <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.home_zip_code" ref="zip_code">
                    </div>

                    <div class="home-county">
                        <label id="home_county">
                            County/Parish/Borough
                            <changes :changeLog="changeLog['section_b.home_county']" v-if="changeLog['section_b.home_county']"></changes>
                        </label>
                        <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.home_county" ref="county">
                    </div>
                </div>
            </template>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(10) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(10)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(10) > -1">
                    <p><strong>Question 10.</strong> Current Residence Address: A rural route (RR) may be accepted provided the transferee/buyer lives in a State or locality where it is considered a legal residence address.</p>
                    <p>If the transferee/buyer is a member of the Armed Forces on active duty, his/her State of residence is the State in which his/her permanent duty station is located. If the service member is acquiring a firearm in a State where his/her permanent duty station is located, but resides in a different State, the transferee/buyer must list both his/her permanent duty station address and residence address. If the transferee/buyer has two States of residence, the transferee/buyer should list his/her current residence address (e.g., if the transferee/buyer is purchasing a firearm while staying at his/her weekend home in State X, list the address in State X).</p>
                </div>
            </div>

            <div id="place_of_birth" class="form-line label">11. Place of Birth</div>
            <div class="form-line four-columns place-of-birth">
				<label id="birth_city">U.S. City
                    <changes :changeLog="changeLog['section_b.birth_city']" v-if="changeLog['section_b.birth_city']"></changes>
    				<input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.birth_city" ref="birth_city">
				</label>
                <label id="place_of_birth_state" for="pob_code">State
                    <changes :changeLog="changeLog['section_b.pob_code']" v-if="changeLog['section_b.pob_code']"></changes>
                    <select :disabled="statusCodes.B_COMPLETE" name="pob_code" v-model="form.form_data.section_b.pob_code" ref="pob_code">
    				    <option :value="null">State...</option>
    				    <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
    				</select>
                </label>
                <span>- OR -</span>
                <label id="foreign_country">Foreign Country
                    <changes :changeLog="changeLog['section_b.foreign_country']" v-if="changeLog['section_b.foreign_country']"></changes>
    				<select :disabled="statusCodes.B_COMPLETE" v-model="form.form_data.section_b.foreign_country" ref="foreign_country">
    				    <option :value="null">Country...</option>
    				    <option v-for="(country, code) in this.COUNTRIES_LIST" :value="country">{{ country }}</option>
    				</select>
                </label>
            </div>
            <div class="form-line four-columns align-items-start">
                <div class="height">
                    <div class="span-two label">12. Height</div>
                    <label id="feet">
                        Ft.
                        <changes :changeLog="changeLog['section_b.feet']" v-if="changeLog['section_b.feet']"></changes>
                        <input :disabled="statusCodes.B_COMPLETE" type="number" v-model="form.form_data.section_b.feet" ref="feet">
                    </label>
                    <label id="inches">
                        In.
                        <changes :changeLog="changeLog['section_b.inches']" v-if="changeLog['section_b.inches']"></changes>
                        <input :disabled="statusCodes.B_COMPLETE" type="number" v-model="form.form_data.section_b.inches" ref="inches">
                    </label>
                </div>
                <div class="weight">
                    <div id="weight" class="label">
                        13. Weight (lbs)
                        <changes :changeLog="changeLog['section_b.weight']" v-if="changeLog['section_b.weight']"></changes>
                    </div>
                    <input :disabled="statusCodes.B_COMPLETE" type="number" v-model="form.form_data.section_b.weight" ref="weight">
                </div>
                <div class="sex span-two">
                    <div id="sex" class="label">
                        14. Sex
                        <changes :changeLog="changeLog['section_b.gender_code']" v-if="changeLog['section_b.gender_code']">
                            <div class="log-time">{{ changeLog.log_time }}</div>
                            <div class="old-value" v-if="changeLog['section_b.gender_code'].old_value == 'M'">Male</div>
                            <div class="old-value" v-if="changeLog['section_b.gender_code'].old_value == 'F'">Female</div>
                            <div class="old-value" v-if="changeLog['section_b.gender_code'].old_value == 'U'">Non-Binary</div>
                        </changes>
                    </div>
                    <label class="radio first">
    					<input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.gender_code" value="M">
    					<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Male</span>
    				</label>
    				<label class="radio">
    					<input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.gender_code" value="F">
    					<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Female</span>
    				</label>
                    <label class="radio last">
    					<input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.gender_code" value="U">
    					<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Non-Binary</span>
    				</label>
                </div>
                <div class="help-box-outer form-full">
                    <div :class="['help-box-label', showHelp.indexOf(14) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(14)"><i class="fas fa-info"></i></div>
                    <div class="help-box"  v-show="showHelp.indexOf(14) > -1">
                        Question 14. Sex: Individuals with neither male nor female on their identification document(s) should check Non-Binary.
                    </div>
                </div>
            </div>
            <div id="birthdate" class="form-line label">
                15. Birth Date
                <changes :changeLog="changeLog['section_b.birthdate']" v-if="changeLog['section_b.birthdate']"></changes>
            </div>
            <div class="form-line four-columns">
                <date-input :disabled="statusCodes.B_COMPLETE" :class="{ error: signedDateError }" v-model="form.form_data.section_b.birthdate"></date-input>
            </div>
            <div class="form-line two-columns">
                <div>
                    <div class="label">
                        16. Social Security Number (optional, but will help prevent misidentification)
                        <changes :changeLog="changeLog['section_b.ssn']" v-if="changeLog['section_b.ssn']"></changes>
                    </div>
                    <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.ssn">
                </div>
                <div>
                    <div class="label">
                        17. Unique Personal Identification Number (UPIN) or Appeals Management Database Identification (AMD ID) (if applicable)
                        <changes :changeLog="changeLog['section_b.upin']" v-if="changeLog['section_b.upin']"></changes>
                    </div>
                    <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.upin">
                </div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(17) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(17)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(17) > -1">
                    Question 17. Unique Personal Identification Number (UPIN) or Appeals Management Database Identification (AMD ID): For transferees/buyers approved to have information maintained about them in the FBI NICS Voluntary Appeal File, NICS will provide them with a UPIN, which the transferee/buyer should record in question 17. The AMD ID is a number that will be provided to an appellant on certain types of overturned appeals and should also be recorded in question 17. The transferor/seller should provide the UPIN/AMD ID when conducting background checks through the NICS or the State POC.
                </div>
            </div>

            <div class="form-line two-columns" style="grid-template-columns: 1fr 3fr;">
                <div class="ethnicity">
    				<div id="ethnicity" class="label">
                        18.a. Ethnicity
                        <changes :changeLog="changeLog['section_b.ethnicity']" v-if="changeLog['section_b.ethnicity']">
                            <div class="log-time">{{ changeLog.log_time }}</div>
                            <div class="old-value" v-if="changeLog['section_b.ethnicity'].old_value == 'hispanic'">Yes</div>
                            <div class="old-value" v-if="changeLog['section_b.ethnicity'].old_value == 'nonhispanic'">No</div>
                        </changes>
                    </div>
    				<label>Hispanic or Latino</label>
    				<div class="control-group">
    					<label class="radio first">
    						<input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.ethnicity" value="hispanic">
    						<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
    					</label>
    					<label class="radio last">
    						<input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.ethnicity" value="nonhispanic">
    						<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
    					</label>
    				</div>
    			</div>

    			<div class="race">
    				<div id="customer_race" class="label">
                        18.b. Race
                        <changes :changeLog="changeLog" v-if="changeLog['section_b.customer_race.l4'] || changeLog['section_b.customer_race.l2'] || changeLog['section_b.customer_race.l6'] || changeLog['section_b.customer_race.l1'] || changeLog['section_b.customer_race.l5']">
                            <div class="log-time">{{ changeLog.log_time }}</div>
                            <div class="old-value" v-if="changeLog['section_b.customer_race.l4'] && changeLog['section_b.customer_race.l4'].old_value != ''">American Indian or Alaskan Native</div>
                            <div class="old-value" v-if="changeLog['section_b.customer_race.l2'] && changeLog['section_b.customer_race.l2'].old_value != ''">Black or African American</div>
                            <div class="old-value" v-if="changeLog['section_b.customer_race.l6'] && changeLog['section_b.customer_race.l6'].old_value != ''">White</div>
                            <div class="old-value" v-if="changeLog['section_b.customer_race.l1'] && changeLog['section_b.customer_race.l1'].old_value != ''">Asian</div>
                            <div class="old-value" v-if="changeLog['section_b.customer_race.l5'] && changeLog['section_b.customer_race.l5'].old_value != ''">Native Hawaiian or Other Pacific Islander</div>
                        </changes>
                    </div>
                    <label>(Select one or more race in 18.b. Both 18.a. and 18.b. must be answered.)</label>
    				<div id="race" style="max-width: 45em;">
    					<label class="checkbox">
    						<input :disabled="statusCodes.B_COMPLETE" type="checkbox" v-model="form.form_data.section_b.customer_race.l4">
    						<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>American Indian or Alaskan Native</span>
    					</label>
    					<label class="checkbox">
    						<input :disabled="statusCodes.B_COMPLETE" type="checkbox" v-model="form.form_data.section_b.customer_race.l2">
    						<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Black or African American</span>
    					</label>
    					<label class="checkbox">
    						<input :disabled="statusCodes.B_COMPLETE" type="checkbox" v-model="form.form_data.section_b.customer_race.l6">
    						<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>White</span>
    					</label>
    					<label class="checkbox">
    						<input :disabled="statusCodes.B_COMPLETE" type="checkbox" v-model="form.form_data.section_b.customer_race.l1">
    						<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Asian</span>
    					</label>
    					<label class="checkbox">
    						<input :disabled="statusCodes.B_COMPLETE" type="checkbox" v-model="form.form_data.section_b.customer_race.l5">
    						<span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Native Hawaiian or Other Pacific Islander</span>
    					</label>
    				</div>
    			</div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(18) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(18)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(18) > -1">
                    <p>Questions 18.a. and 18.b. Ethnicity and Race: Federal regulations (27 CFR 478.124(c)(1)) require licensees to obtain the race of the transferee/buyer. This information helps the FBI and/or State POC make or rule out potential matches during the background check process and can assist with criminal investigations.</p>

                    <p>Ethnicity refers to a person's heritage. Persons of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race, are considered Hispanic or Latino.</p>

                    <p>Race - one or more of the following responses must be selected: (1) American Indian or Alaska Native - A person having origins in any of the original peoples of North and South America (including Central America), and who maintains a tribal affiliation or community attachment; (2) Asian - A person having origins in any of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam; (3) Black or African American - A person having origins in any of the Black racial groups of Africa; (4) Native Hawaiian or Other Pacific Islander - A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands; and/or (5) White - A person having origins in any of the original peoples of Europe, the Middle East, or North Africa. Select the closest representation for any other race or ethnicity that does not fall within those indicated.</p>
                </div>
            </div>
            <div id="citizen_status_code" class="form-line label">
                19. Country of Citizenship: (Check/List more than one, if applicable. Nationals of the United States may check U.S.A.)
                <changes :changeLog="changeLog['section_b.citizen_status_code']" v-if="changeLog['section_b.citizen_status_code']">
                    <div class="log-time">{{ changeLog.log_time }}</div>
                    <div class="old-value" v-if="changeLog['section_b.citizen_status_code'] != 'C'">United States of America (U.S.A.)</div>
                    <div class="old-value" v-if="changeLog['section_b.citizen_status_code'] != 'F'">
                        Other Country/Countries
                        <div class="old-value" v-if="changeLog['section_b.citizen_country_code']">{{ changeLog['section_b.citizen_country_code'].old_value }}</div>
                        <div class="old-value" v-if="changeLog['section_b.citizen_country_code_2']">{{ changeLog['section_b.citizen_country_code_2'].old_value }}</div>
                        <div class="old-value" v-if="changeLog['section_b.citizen_country_code_3']">{{ changeLog['section_b.citizen_country_code_3'].old_value }}</div>
                    </div>
                </changes>
            </div>
            <div class="form-line" id="origin_country">
                <label class="usa-label radio first">
                    <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.citizen_status_code" value="C" id="usa">
                    <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>United States of America (U.S.A.)</span>
                </label>
                <label class="other-label radio last">
                    <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.citizen_status_code" value="F" id="other">
                    <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Other Country/Countries (Specify):</span>
                </label>
                <template v-if="form.form_data.section_b.citizen_status_code == 'F'">
                    <select :disabled="statusCodes.B_COMPLETE" v-model="form.form_data.section_b.citizen_country_code">
                        <option value>Country...</option>
                        <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
                    </select>
                    <select :disabled="statusCodes.B_COMPLETE" v-model="form.form_data.section_b.citizen_country_code_2" v-if="form.form_data.section_b.citizen_country_code">
                        <option value>Country...</option>
                        <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
                    </select>
                    <select :disabled="statusCodes.B_COMPLETE" v-model="form.form_data.section_b.citizen_country_code_3" v-if="form.form_data.section_b.citizen_country_code && form.form_data.section_b.citizen_country_code_2">
                        <option value>Country...</option>
                        <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
                    </select>
                </template>
            </div>
            <div class="form-line three-columns position-relative">
                <div id="mnu1" for="mnu1">20. If you are an alien, record your U.S.-issued alien or admission number (AR#, USCIS#, or I94#)</div>
                <input :disabled="statusCodes.B_COMPLETE" type="text" v-model="form.form_data.section_b.mnu1">
				<select id="mnu_type_code1" v-model="form.form_data.section_b.mnu_type_code1" style="width: 7em;" :disabled="statusCodes.B_COMPLETE">
					<option value="">Select...</option>
					<option value="AR">Alien Registration Number or USCIS</option>
                    <option value="I9">Non-Immigrant Admissions Number</option>
				</select>
                <changes :changeLog="changeLog" v-if="changeLog['section_b.mnu1']">
                    <div class="log-time">{{ changeLog.log_time }}</div>
                    <div class="old-value">{{ changeLog['section_b.mnu1'].old_value }}</div>
                    <div class="old-value" v-if="changeLog['section_b.mnu_type_code1'] == 'AR'">AR#</div>
                    <div class="old-value" v-if="changeLog['section_b.mnu_type_code1'] == 'USCIS'">USCIS#</div>
                    <div class="old-value" v-if="changeLog['section_b.mnu_type_code1'] == 'I94'">I94#</div>
                </changes>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(20) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(20)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(20) > -1">
                    Question 20. U.S.-issued Alien Number or Admission Number: U.S.-issued alien and admission numbers may be found on the following U.S. Department of Homeland Security documents: Legal Resident Card or Employment Authorization Card (AR# or USCIS#); Arrival/Departure Record, Form I94, or Form 797A (I94#). Additional information can be obtained from www.cbp.gov. If you are a U.S. citizen or U.S. national, the response to this question should be left blank.
                </div>
            </div>

            <div class="form-line">21. Answer the following questions by checking or marking either the “yes” or “no” box to the right of the questions</div>
            <div class="form-line label three-one-columns">
                <label id="actual_buyer" for="actual_buyer" class="small label" :class="{ error: form.form_data.section_b.actual_buyer == 'no' }">a. Are you the actual transferee/buyer of the firearm(s) listed on this form and any continuation sheet(s) (ATF Form 5300.9A)? Warning: You are not the actual transferee/buyer if you are acquiring the firearm(s) on behalf of another person. If you are not the actual transferee/buyer, the licensee cannot transfer the firearm(s) to you. Exception: If you are only picking up a repaired firearm(s) for another person, you are not required to answer 21.a. and may proceed to question 21.b.</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.actual_buyer" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.actual_buyer" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.actual_buyer']" v-if="changeLog['section_b.actual_buyer']"></changes>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.a.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.a.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.a.') > -1">
                    <p>Question 21.a. Actual Transferee/Buyer: For purposes of this form, a person is the actual transferee/buyer if he/she is purchasing the firearm for him/herself or otherwise acquiring the firearm for him/herself. (e.g., redeeming the firearm from pawn, retrieving it from consignment, firearm raffle winner). A person is also the actual transferee/buyer if he/she is legitimately purchasing the firearm as a bona fide gift for a third party. A gift is not bona fide if another person offered or gave the person completing this form money, service(s), or item(s) of value to acquire the firearm for him/her, or if the other person is prohibited by law from receiving or possessing the firearm.</p>

                    <p>EXAMPLES: Mr. Smith asks Mr. Jones to purchase a firearm for Mr. Smith (who may or may not be prohibited). Mr. Smith gives Mr. Jones the money for the firearm. Mr. Jones is NOT THE ACTUAL TRANSFEREE/BUYER of the firearm and must answer "no" to question 21.a. The licensee may not transfer the firearm to Mr. Jones. However, if Mr. Brown buys the firearm with his own money to give to Mr. Black as a gift (with no service or tangible thing of value provided by Mr. Black), Mr. Brown is the actual transferee/buyer of the firearm and should answer "yes" to question 21.a. However, the transferor/seller may not transfer a firearm to any person he/she knows or has reasonable cause to believe is prohibited under 18 U.S.C. 922(g), (h), (n), or (x).</p>
                </div>
            </div>

            <div class="form-line label three-one-columns">
                <label id="under_indictment" for="under_indictment" class="small label" :class="{ error: form.form_data.section_b.under_indictment == 'yes' }">b. Are you under indictment or information in any court for a felony, or any other crime for which the judge could imprison you for more than one year, or are you a current member of the military who has been charged with violation(s) of the Uniform Code of Military Justice and whose charge(s) have been referred to a general court-martial?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.under_indictment" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.under_indictment" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.under_indictment']" v-if="changeLog['section_b.under_indictment']"></changes>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.b.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.b.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.b.') > -1">
                    <p>Questions 21.b. - 21.l. Prohibited Persons: Generally, 18 U.S.C. 922(g) prohibits the shipment, transportation, receipt, or possession in or affecting interstate commerce of a firearm by one who: has been convicted of a felony in any Federal, including a general court-martial, State or local court, or any other crime, punishable by imprisonment for a term exceeding one year; is a fugitive from justice; is an unlawful user of, or addicted to, marijuana or any depressant, stimulant, or narcotic drug, or any other controlled substance; has been adjudicated as a mental defective or has been committed to a mental institution; has been discharged from the Armed Forces under dishonorable conditions; is subject to certain restraining orders; convicted of a misdemeanor crime of domestic violence under Federal, including a general court-martial, State or Tribal law; has renounced his/her U.S. citizenship; is an alien illegally in the United States or an alien admitted to the United States under a nonimmigrant visa. Furthermore, section 922(n) prohibits the shipment, transportation, or receipt in or affecting interstate commerce of a firearm by one who is under indictment or information for a felony in any Federal, including a general court-martial, State or local court, or any other crime, punishable by imprisonment for a term exceeding one year. An information is a formal accusation of a crime verified by a prosecutor.</p>
                    <p>A member of the Armed Forces must answer "yes" to 21.b. if charged with an offense that is referred to a general court-martial. A current or former member of the Armed Forces must answer "yes" to 21.c. if convicted under a general court-martial.</p>
                    <p>Discharged "under dishonorable conditions" means separation from the Armed Forces resulting from a dishonorable discharge or dismissal adjudged by a general court-martial. That term does not include any other discharge or separation.</p>
                    <p>EXCEPTION: A person is not prohibited from receiving or possessing a firearm
                    if that person: (1) has been convicted of any Federal or State offense pertaining to antitrust violations, unfair trade practices, restraints of trade, or other similar offenses relating to the regulation of business practices; (2) has been convicted of a State misdemeanor punishable by imprisonment of two years or less; or (3) following conviction of a felony or other crime for which the judge could have imprisoned the person for more than one year, or a misdemeanor crime of domestic violence, has received a pardon, an expungement or set aside of the conviction, or has lost and regained civil rights (the right to vote, sit on a jury, and hold public office) in the jurisdiction in which the conviction occurred, AND the law of the convicting jurisdiction does not prohibit the person from receiving or possessing firearms. Person subject to any of these exceptions, or who received relief from disabilities under 18 U.S.C. 925(c), should answer "no" to the applicable question.</p>
                </div>
            </div>

            <div class="form-line label three-one-columns">
                <label id="convict" for="convict" class="small label" :class="{ error: form.form_data.section_b.convict == 'yes' }">c. Have you ever been convicted in any court, including a military court, of a felony, or any other crime for which the judge could have imprisoned you for more than one year, even if you received a shorter sentence including probation?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.convict" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.convict" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.convict']" v-if="changeLog['section_b.convict']"></changes>
            </div>

            <div class="form-line label three-one-columns">
                <label id="fugitive" for="fugitive" class="small label" :class="{ error: form.form_data.section_b.fugitive == 'yes' }">d. Are you a fugitive from justice?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.fugitive" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.fugitive" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.fugitive']" v-if="changeLog['section_b.fugitive']"></changes>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.d.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.d.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.d.') > -1">
                    <p>Question 21.d. Fugitive from Justice: Any person who has fled from any State to avoid prosecution for a felony or a misdemeanor; or any person who leaves the State to avoid giving testimony in any criminal proceeding. The term also includes any person who knows that misdemeanor or felony charges are pending against such person and who leaves the State of prosecution.</p>
                </div>
            </div>

            <div class="form-line label three-one-columns">
                <label id="addict" for="addict" class="small label" :class="{ error: form.form_data.section_b.addict == 'yes' }">e. Are you an unlawful user of, or addicted to, marijuana or any depressant, stimulant, narcotic drug, or any other controlled substance? <strong>Warning:</strong> The use or possession of marijuana remains unlawful under Federal law regardless of whether it has been legalized or decriminalized  for medicinal or recreational purposes in the state where you reside.</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.addict" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.addict" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.addict']" v-if="changeLog['section_b.addict']"></changes>
            </div>

            <div class="form-line label three-one-columns">
                <label id="mental" for="mental" class="small label" :class="{ error: form.form_data.section_b.mental == 'yes' }">f. Have you ever been adjudicated as a mental defective OR have you ever been committed to a mental institution?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.mental" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.mental" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.mental']" v-if="changeLog['section_b.mental']"></changes>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(8) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(8)"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf(8) > -1">
                    <p>Question 21.f. Adjudicated as a Mental Defective: A determination by a court, board, commission, or other lawful authority that a person, as a result of marked subnormal intelligence, or mental illness, incompetency, condition, or disease: (1) is a danger to himself or to others; or (2) lacks the mental capacity to contract or manage his own affairs. This term shall include: (1) a finding of insanity by a court in a criminal case; and (2) those persons found incompetent to stand trial or found not guilty by reason of lack of mental responsibility.</p>
                    <p>Committed to a Mental Institution: A formal commitment of a person to a mental institution by a court, board, commission, or other lawful authority. The term includes a commitment to a mental institution involuntarily. The term includes commitment for mental defectiveness or mental illness. It also includes commitments for other reasons, such as for drug use. The term does not include a person in a mental institution for observation or a voluntary admission to a mental institution.</p>
                    <p>EXCEPTION: Under the NICS Improvement Amendments Act of 2007, a person who has been adjudicated as a mental defective or committed to a mental institution in a State proceeding is not prohibited by the adjudication or commitment if the person has been granted relief by the adjudicating/committing State pursuant to a qualifying mental health relief from disabilities program. Also, a person who has been adjudicated as a mental defective or committed to a mental institution by a department or agency of Federal Government is not prohibited by the adjudication or commitment if either: (a) the person's adjudication or commitment was set aside or expunged by the adjudicating/committing agency; (b) the person has been fully released or discharged from all mandatory treatment, supervision, or monitoring by the agency; (c) the person was found by the agency to no longer suffer from the mental health condition that served as the basis of the initial adjudication/commitment; (d) the adjudication or commitment, respectively, is based solely on a medical finding of disability, without an opportunity for a hearing by a court, board, commission, or other lawful authority, and the person has not been adjudicated as a mental defective consistent with section 922(g)(4) of title 18, United States Code; or (e) the person was granted relief from the adjudicating/committing agency pursuant to a qualified mental health relief from disabilities program. This exception to an adjudication or commitment by a Federal department or agency does not apply to any person who was adjudicated to be not guilty by reason of insanity, or based on lack of mental responsibility, or found incompetent to stand trial, in any criminal case or under the Uniform Code of Military Justice. Persons who fall within one of the above exceptions should answer "no" to question 21.f.</p>
                </div>
            </div>

            <div class="form-line label three-one-columns">
                <label id="dishonorable_discharge" for="dishonorable_discharge" class="small label" :class="{ error: form.form_data.section_b.dishonorable_discharge == 'yes' }">g. Have you ever been discharged from the Armed Forces under dishonorable conditions?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.dishonorable_discharge" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.dishonorable_discharge" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.dishonorable_discharge']" v-if="changeLog['section_b.dishonorable_discharge']"></changes>
            </div>

            <div class="form-line label three-one-columns">
                <label id="restraining_order" for="restraining_order" class="small label" :class="{ error: form.form_data.section_b.restraining_order == 'yes' }">h. Are you subject to a court order, including a Military Protection Order issued by a military judge or magistrate, restraining you from harassing, stalking, or threatening your child or an intimate partner or child of such partner?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.restraining_order" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.restraining_order" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.restraining_order']" v-if="changeLog['section_b.restraining_order']"></changes>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.h.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.h.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.h.') > -1">
                    <p>Question 21.h. Qualifying Restraining Orders: Under 18 U.S.C. 922, firearms may not be sold to or received by persons subject to a court order that: (A) was issued after a hearing which the person received actual notice of and had an opportunity to participate in; (B) restrains such person from harassing, stalking, or threatening an intimate partner or child of such intimate partner or person, or engaging in other conduct that would place an intimate partner in reasonable fear of bodily injury to the partner or child; and (C)(i) includes a finding that such person represents a credible threat to the physical safety of such intimate partner or child; or (ii) by its terms explicitly prohibits the use, attempted use, or threatened use of physical force against such intimate partner or child that would reasonably be expected to cause bodily injury. An "intimate partner" of a person is: the spouse or former spouse of the person, the parent of a child of the person, or an individual who cohabitates or has cohabitated with the person.</p>
                </div>
            </div>

            <div class="form-line label three-one-columns">
                <label id="domestic_violence" for="domestic_violence" class="small label" :class="{ error: form.form_data.section_b.domestic_violence == 'yes' }">i. Have you ever been convicted in any court of a misdemeanor crime of domestic violence, or are you or have you ever been a member of the military and been convicted of a crime that included, as an element, the use of force against a person as identified in the instructions?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.domestic_violence" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.domestic_violence" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.domestic_violence']" v-if="changeLog['section_b.domestic_violence']"></changes>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.i.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.i.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.i.') > -1">
                    <p>Question 21.i. Misdemeanor Crime of Domestic Violence: A Federal, including a general court-martial, State, local, or tribal offense that is a misdemeanor under Federal, State, or tribal law and has, as an element, the use or attempted use of physical force, or the threatened use of a deadly weapon, committed by a current or former spouse, parent, or guardian of the victim, by a person with whom the victim shares a child in common, by a person who is cohabitating with, or has cohabited with the victim as a spouse, parent, or guardian, or by a person similarly situated toa spouse, parent, or guardian of the victim. The term includes all misdemeanors that have as an element the use or attempted use of physical force or the threatened use of a deadly weapon (e.g., assault and battery), if the offense is committed by one of the defined parties. (See Exception to 21.b. - 21.l.) A person who has been convicted of a misdemeanor crime of domestic violence also is not prohibited unless: (1) the person was represented by a lawyer or gave up the right to a lawyer; or (2) if the person was entitled to a jury, was tried by a jury, or gave up the right to a jury trial. Persons subject to this exception should answer "no" to 21.i.</p>

                    <p>A current or former member of the military who has been convicted of a violation of the Uniform Code of Military Justice that included, as an element, the use of force against a person as identified in the instructions under question 21.i. must answer "yes" to this question. This may include a qualifying offense that was referred to a special or general court-martial.</p>
                </div>
            </div>

            <div class="form-line label three-one-columns">
                <label id="renounced_citizenship" for="renounced_citizenship" class="small label" :class="{ error: form.form_data.section_b.renounced_citizenship == 'yes' }">j. Have you ever renounced your United States citizenship?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.renounced_citizenship" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.renounced_citizenship" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.renounced_citizenship']" v-if="changeLog['section_b.renounced_citizenship']"></changes>
            </div>

            <div class="form-line label three-one-columns">
                <label id="illegal_alien" for="illegal_alien" class="small label" :class="{ error: form.form_data.section_b.illegal_alien == 'yes' }">k. Are you an alien <strong>illegally</strong> or <strong>unlawfully</strong> in the United States?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.illegal_alien" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.illegal_alien" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.illegal_alien']" v-if="changeLog['section_b.illegal_alien']"></changes>
            </div>

            <div class="form-line label three-one-columns">
                <div id="legal_alien" class="label">21.l.1. Are you an alien who has been admitted to the United States under a nonimmigrant visa?</div>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.legal_alien" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.legal_alien" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.legal_alien']" v-if="changeLog['section_b.legal_alien']"></changes>
            </div>

            <div class="form-line label three-one-columns">
                <div id="exc_code" class="label">21.l.2. If you are such an alien do you fall within any of the exceptions stated in the instructions?</div>
                <br><b>(U.S. citizens/nationals leave 21.l.2. blank)</b>
                <div class="control-group">
                    <label class="radio first">
                        <input :disabled="(form.form_data.section_b.citizen_status_code == 'C') || statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.exc_code" value="yes">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input :disabled="(form.form_data.section_b.citizen_status_code == 'C') || statusCodes.B_COMPLETE" type="radio" v-model="form.form_data.section_b.exc_code" value="no">
                        <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
                <changes :changeLog="changeLog['section_b.exc_code']" v-if="changeLog['section_b.exc_code']"></changes>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.l.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.l.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.l.') > -1">
                    <p>Question 21.l. Immigration Status: An alien admitted to the United States under
                    a nonimmigrant visa includes, among others, persons visiting the United States temporarily for business or pleasure, persons studying in the United States who maintain a residence abroad, and certain temporary foreign workers. These aliens must answer "yes" to this question and provide the additional documentation as required under question 26.d.to establish they are excepted from the nonimmigrant alien prohibition. Permanent resident aliens and aliens legally admitted to the United States pursuant to either the Visa Waiver Program or to regulations otherwise exempting them from visa requirements may answer "no" to this question, leave 21.l.2 blank and are not required to submit the additional documentation under question 26.d.</p>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <strong>I certify that my answers in Section B are true, correct, and complete. I have read and understand the Notices, Instructions, and Definitions on ATF Form 4473. I understand that answering “yes” to question 21.a. if I am not the actual transferee/buyer is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I understand that a person who answers “yes” to any of the questions 21.b. through 21.k. is prohibited from receiving or possessing a firearm. I understand that a person who answers “yes” to question 21.l.1. is prohibited from receiving or possessing a firearm, unless the person answers “yes” to question 21.l.2. and provides the documentation required in 26.d. I also understand that making any false oral or written statement, or exhibiting any false or misrepresented identification with respect to this transaction, is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I further understand that the repetitive purchase of firearms for the purpose of resale for livelihood and profit without a Federal firearms license is a violation of Federal law.</strong>
                <label class="checkbox" id="i_certify">
                    <input :disabled="statusCodes.B_COMPLETE" type="checkbox" class="half-input" v-model="form.form_data.section_b.i_certify">
                    <span :class="{disabled: statusCodes.B_COMPLETE}"><i class="fas fa-check-circle"></i></span>
                </label>
            </div>

            <div class="form-line three-one-columns">
                <div>
                    <div id="signature">22. Transferee’s/Buyer’s Signature</div>
                    <div class="signature-group" v-if="form.form_data && form.form_data.section_b.signature">
                        <img class="signature" :src="form.form_data.section_b.signature" alt="">
                    </div>
                </div>
                <div>
                    <div id="signed_date">23. Date</div>
                    <date-input :disabled="true" :class="{ error: signedDateError }" v-model="form.form_data.section_b.signed_date"></date-input>
                </div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('22') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('22')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('22') > -1">
                    <p>Question 22. Transferee/Buyer Certification: Under 18 U.S.C. 922(a)(1), it is unlawful for a person to engage in the business of dealing in firearms without a license. A person is engaged in the business of dealing in firearms if he/she devotes time, attention, and labor to dealing in firearms as a regular course of trade or business with the principal objective of livelihood and profit through the repetitive purchase and resale of firearms. A license is not required of a person who only makes occasional sales, exchanges, or purchases of firearms for the enhancement of a personal collection or for a hobby, or who sells all or part of his/her personal collection of firearms.</p>
                </div>
            </div>
        </div>
        <!-- /.section_b -->

        <div class="form section-c list dealer-form" v-if="formSection == 'section_c'" ref="section_top">
            <h2 class="section-title">Section C - Must Be Completed By Transferor/Seller Prior To The Transfer Of The Firearm(s)</h2>
            <div class="form-line two-columns">
                <div class="customer-trans-purpose">
                    <label>
                        24. Category of firearm(s) to be transferred
                        <label class="changes" v-if="changeLog['section_c.customer_trans_purpose.l1'] || changeLog['section_c.customer_trans_purpose.l2'] || changeLog['section_c.customer_trans_purpose.l3']">
                            <input type="checkbox">
                            <span class="initials" v-if="changeLog['section_c.customer_trans_purpose.l1']">{{ changeLog['section_c.customer_trans_purpose.l1'].user_initials }}</span>
                            <span class="initials" v-else-if="changeLog['section_c.customer_trans_purpose.l2']">{{ changeLog['section_c.customer_trans_purpose.l2'].user_initials }}</span>
                            <span class="initials" v-else>{{ changeLog['section_c.customer_trans_purpose.l3'] }}</span>
                            <div class="change-list">
                                <div class="log-time" v-if="changeLog['section_c.customer_trans_purpose.l1']">{{ $moment(changeLog['section_c.customer_trans_purpose.l1'].log_time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm') }}</div>
                                <div class="log-time" v-else-if="changeLog['section_c.customer_trans_purpose.l2']">{{ $moment(changeLog['section_c.customer_trans_purpose.l2'].log_time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm') }}</div>
                                <div class="log-time" v-else>{{ $moment(changeLog['section_c.customer_trans_purpose.l3'].log_time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm') }}</div>
                                <div class="old-value" v-if="changeLog['section_c.customer_trans_purpose.l1']">
                                    <span>Handun: </span><span>{{ changeLog['section_c.customer_trans_purpose.l1'].old_value ? 'true' : 'BLANK' }}</span>
                                </div>
                                <div class="old-value" v-if="changeLog['section_c.customer_trans_purpose.l2']">
                                    <span>Long Gun: </span><span>{{ changeLog['section_c.customer_trans_purpose.l2'].old_value ? 'true' : 'BLANK' }}</span>
                                </div>
                                <div class="old-value" v-if="changeLog['section_c.customer_trans_purpose.l3']">
                                    <span>Other Firearm: </span><span>{{ changeLog['section_c.customer_trans_purpose.l3'].old_value ? 'true' : 'BLANK' }}</span>
                                </div>
                            </div>
                        </label>
                    </label>
                    <div>(check or mark all that apply)</div>
                    <label class="checkbox short" :class="{ disabled: statusCodes.E_COMPLETE }">
                        <input :disabled="statusCodes.E_COMPLETE" type="checkbox" v-model="form.form_data.section_c.customer_trans_purpose.l1">
                        <span :class="{disabled: statusCodes.E_COMPLETE}"><i class="fas fa-check-circle"></i>Handgun</span>
                    </label>
					<label class="checkbox short" :class="{ disabled: statusCodes.E_COMPLETE }">
                        <input :disabled="statusCodes.E_COMPLETE" type="checkbox" v-model="form.form_data.section_c.customer_trans_purpose.l2">
                        <span :class="['more-info', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Long Gun<i class="fas fa-info-circle">
                            <span class="info">(rifle or shotgun)</span></i>
                        </span>
                    </label>
					<label class="checkbox short" :class="{ disabled: statusCodes.E_COMPLETE }">
                        <input :disabled="statusCodes.E_COMPLETE" type="checkbox" v-model="form.form_data.section_c.customer_trans_purpose.l3">
                        <span :class="['more-info', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Other Firearm<i class="fas fa-info-circle">
                            <span class="info">(frame, receiver, etc.)</span></i>
                        </span>
                    </label>
                </div>
                <div class="gun-show">
                    <div>25. If sale or transfer is at a qualifying gun show or event</div>
                    <label>
                        Name of function:
                        <changes :changeLog="changeLog['section_c.gun_show_name']" v-if="changeLog['section_c.gun_show_name']"></changes>
                    </label>
                    <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.gun_show_name">
                        <!-- <changes v-if="changeLog['renounced_citizenship'] && !newForm" :changeLog="changeLog['renounced_citizenship']"></changes> -->
					<label>
                        City, State:
                        <changes :changeLog="changeLog['section_c.gun_show_location']" v-if="changeLog['section_c.gun_show_location']"></changes>
                    </label>
                    <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.gun_show_location">
                        <!-- <changes v-if="changeLog['renounced_citizenship'] && !newForm" :changeLog="changeLog['renounced_citizenship']"></changes> -->
                </div>

            </div>

            <div class="help-box-outer form-half">
				<div :class="['help-box-label', showHelp.indexOf(24) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(24)"><i class="fas fa-info"></i></div>
				<div class="help-box"  v-show="showHelp.indexOf(24) > -1">
					<p>Question 24. Category of Firearm(s): "Other" refers to frames, receivers, and other firearms that are neither handguns nor long guns (rifles or shotguns), such as firearms having a pistol grip that expel a shotgun shell, or National Firearms Act (NFA) firearms, including silencers.</p>
					<p>If a frame or receiver can only be made into a long gun (rifle or shotgun), it is still a frame or receiver, not a handgun or long gun. All frames and receivers are "firearms" by definition, and subject to the same GCA limitations. See Section 921(a)(3) (B). Section 922(b)(1) makes it unlawful for a licensee to sell any firearm other than a shotgun or rifle to any person under the age of 21. Since a frame or receiver for a firearm, to include one that can only be made into a long gun, is a "firearm other than a shotgun or rifle," it cannot be transferred to anyone under the age of 21, nor can these firearms be transferred to anyone who is not a resident of the State where the transfer is to take place. Also, note that multiple sales forms are not required for frames or receivers of any firearms, or pistol grip shotguns, since they are not "pistols or revolvers" under Section 923(g)(3)(A).</p>

					<p>Question 25. Qualifying Gun Show or Event: As defined in 27 CFR 478.100, a gun show or event is a function sponsored by any national, State, or local organization, devoted to the collection, competitive use, or other sporting use of firearms, or an organization or association that sponsors functions devoted to the collection, competitive use, or other sporting use of firearms in the community.</p>

				</div>
			</div>

            <div class="form-full label">26.a. Identification (e.g., Virginia driver’s license (VA DL) or other valid government-issued photo identification including military ID.)</div>
            <div class="form-line three-columns" style="align-items: start;">
                <div>
                    <label class="label-with-input">
                        Issuing Authority
                        <changes :changeLog="changeLog['section_c.buyer_identification_issuing_authority_and_type']" v-if="changeLog['section_c.buyer_identification_issuing_authority_and_type']"></changes>
                        <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.buyer_identification_issuing_authority_and_type">
                    </label>
                    <label class="label-with-input">
                        Type of Identification
                        <changes :changeLog="changeLog['section_c.buyer_identification_type_code']" v-if="changeLog['section_c.buyer_identification_type_code']"></changes>
                        <select :disabled="statusCodes.E_COMPLETE" v-model="form.form_data.section_c.buyer_identification_type_code">
                            <option value="" title="DefaultDropDownValue">Select...</option>
                            <option value="AF">Air Force Serial Number</option>
                            <option value="AR">Alien Registration Number or USCIS</option>
                            <option value="AS">Army Serial Number, National Guard Serial Number or Air National Guard Serial Number, regardless of State</option>
                            <option value="CI">Candian Social Insurance Number</option>
                            <option value="DL">Driver's License Number - State Issued Identification Card</option>
                            <option value="FN">Fingerprint Identification Number</option>
                            <option value="MC">Marine Corps Serial Number</option>
                            <option value="MD">Mariner's Document or Identification Number</option>
                            <option value="NS">Navy Serial Number</option>
                            <option value="I9">Non-Immigrant Admissions Number</option>
                            <option value="OA">Other Agency Id</option>
                            <option value="PP">Passport Number</option>
                            <option value="PI">Personal Identification Number (this applies only to state-issued numbers)</option>
                            <option value="PS">Port Security Card Number</option>
                            <option value="MP">Royal Canadian Mounted Police Identification Number</option>
                            <option value="SS">Selective Service Number</option>
                            <option value="CG">U.S. Coast Guard Number</option>
                            <option value="VA">Veterans Administration Claim Number</option>
    					</select>
    					<input :disabled="statusCodes.E_COMPLETE" v-if="form.form_data.section_c.buyer_identification_type_code == 'OA'" type="text" v-model="form.form_data.section_c.buyer_identification_type_description" placeholder="ID description, e.g. 'State Firearm License'">
                    </label>
                </div>
                <div>
                    <label>Number on Identification
                        <changes :changeLog="changeLog['section_c.buyer_identification_number']" v-if="changeLog['section_c.buyer_identification_number']"></changes>
                    </label>
                    <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.buyer_identification_number">
                </div>
                <div>
                    <label>Expiration Date of Identification (if any)
                        <changes :changeLog="changeLog['section_c.buyer_identification_expiration_date']" v-if="changeLog['section_c.buyer_identification_expiration_date']"></changes>
                    </label>
                    <date-input :disabled="statusCodes.E_COMPLETE" :allowFuture="true" :allowPast="false" :class="{ error: signedDateError }" v-model="form.form_data.section_c.buyer_identification_expiration_date"></date-input>
                </div>
            </div>

            <div class="help-box-outer form-line">
                <div :class="['help-box-label', showHelp.indexOf('26.a.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('26.a.')"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf('26.a.') > -1">
                    <p>Question 26.a. Identification: Before a licensee may sell or deliver a firearm to a nonlicensee, the licensee must establish the identity, place of residence, and age of the transferee/buyer. The transferee/buyer must provide a valid government-issued photo identification document to the transferor/seller that contains the transferee's/ buyer's name, residence address, and date of birth. A driver's license or an identification card issued by a State is acceptable. Social Security cards are not acceptable because no address, date of birth, or photograph is shown on the cards.</p>
                    <p>Identification documents such as a driver's license or identification card issued with binary, non-binary, or no sex designation may be used as an identification document. A combination of government-issued documents may be provided. See instructions for question 26.b. Supplemental Documentation.</p>
                    <p>If the transferee/buyer is a member of the Armed Forces on active duty acquiring a firearm in the State where his/her permanent duty station is located, but he/she has a driver's license from another State, the transferor/seller must list the transferee's/ buyer's military identification card in response to question 26.a., in addition to PCS orders as indicated in 26.c.</p>
                </div>
            </div>
            <div class="form-line">
                <label>26.b. Supplemental Government Issued Documentation (if identification document does not show current residence address or full legal name)
                    <changes :changeLog="changeLog['section_c.buyer_supplemental_government_documentation']" v-if="changeLog['section_c.buyer_supplemental_government_documentation']"></changes>
                    <input :disabled="statusCodes.E_COMPLETE" name="buyer_supplemental_government_documentation" type="text" v-model="form.form_data.section_c.buyer_supplemental_government_documentation">
                </label>
            </div>
            <div class="help-box-outer form-line">
                <div :class="['help-box-label', showHelp.indexOf('26.b.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('26.b.')"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf('26.b.') > -1">
                    Question 26.b. Supplemental Documentation: Licensees may accept a combination of valid government-issued documents to satisfy the identification document requirements of the law. The required valid government-issued photo identification document bearing the name, photograph, and date of birth of transferee/buyer may be supplemented by another valid, government-issued document showing the transferee's/buyer's residence address. This supplemental documentation must be recorded in question 26.b., with the issuing authority and type of identification presented. For example, if the transferee/buyer has two States of residence and is trying to buy a handgun in State X, he may provide a driver's license (showing his name, date of birth, and photograph) issued by State Y and another government-issued document (such as a tax document) from State X showing his residence address. A valid electronic document from a government website may be used as supplemental documentation provided it contains the transferee's/buyer's name and current residence address.
                </div>
            </div>
            <div class="form-full">26.c. Official Military Orders Establishing Permanent Change of Station (PCS):</div>
            <div class="form-line three-columns">
                <label>PCS Base/City and State
                    <changes :changeLog="changeLog['section_c.permanent_change_of_station_city_state']" v-if="changeLog['section_c.permanent_change_of_station_city_state']"></changes>
                    <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.permanent_change_of_station_city_state">
                </label>
                <label>PCS Effective Date<br>
                    <changes :changeLog="changeLog['section_c.permanent_change_of_station_effective_date']" v-if="changeLog['section_c.permanent_change_of_station_effective_date']"></changes>
                    <date-input :disabled="statusCodes.E_COMPLETE" :allowFuture="true" v-model="form.form_data.section_c.permanent_change_of_station_effective_date"></date-input>
                </label>
                <label>PCS Order Number (if any)
                    <changes :changeLog="changeLog['section_c.permanent_change_of_station_order_number']" v-if="changeLog['section_c.permanent_change_of_station_order_number']"></changes>
                    <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.permanent_change_of_station_order_number">
                </label>
            </div>
            <div class="help-box-outer form-half">
				<div :class="['help-box-label', showHelp.indexOf('26.c.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('26.c.')"><i class="fas fa-info"></i></div>
				<div class="help-box"  v-show="showHelp.indexOf('26.c.') > -1">
					Question26.c. Official Military Orders Establishing Permanent Change of Station (PCS): Licensees may accept electronic PCS orders to establish residency.
				</div>
			</div>
            <div class="form-line">
                <label>26.d. Exception to the Nonimmigrant Alien Prohibition: If the transferee/buyer answered “yes” to 21.1.2. record the type of documentation showing the exception to the prohibition and attach a copy to this ATF Form 4473
                    <changes :changeLog="changeLog['section_c.exception_to_the_nonimmigrant_alien_prohibition_documentation']" v-if="changeLog['section_c.exception_to_the_nonimmigrant_alien_prohibition_documentation']"></changes>
                    <input :disabled="statusCodes.E_COMPLETE" name="exception_to_the_nonimmigrant_alien_prohibition_documentation" type="text" v-model="form.form_data.section_c.exception_to_the_nonimmigrant_alien_prohibition_documentation">
                </label>
            </div>
            <div class="help-box-outer form-line">
                <div :class="['help-box-label', showHelp.indexOf('26.d.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('26.d.')"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf('26.d.') > -1">
                    Question 26.d. Exceptions to the Nonimmigrant Alien Prohibition: An alien admitted to the United States under a nonimmigrant visa is not prohibited from purchasing, receiving, or possessing a firearm if the alien: (1) is in possession of a hunting license or permit lawfully issued by the Federal Government, a State or local government, or an Indian tribe federally recognized by the Bureau of Indian Affairs, which is valid and unexpired; (2) was admitted to the United States for lawful hunting or sporting purposes; (3) has received a waiver from the prohibition from the Attorney General of the United States; (4) is an official representative of a foreign government who is accredited to the United States Government or the Government's mission to an international organization having its headquarters in the United States; (5) is an official representative of a foreign government who is en route to or from another country to which that alien is accredited; (6) is an official of a foreign government or a distinguished foreign visitor who has been so designated by the Department of State; or (7) is a foreign law enforcement officer of a friendly foreign government entering the United States on official law enforcement business.
                </div>
            </div>

            <div class="controls nics-check">
                <template v-if="readyForNICSCheck && !statusCodes.E_COMPLETE">
                    <div id="nics_online_check_button" class="primary button spaced" @click="nicsOnlineCheck = true">NICS Online Check</div>
                    <div class="primary button col-2 spaced" @click="nicsPhoneCheck = true">NICS Phone Check</div>
                    <div class="primary button disabled spaced" v-if="enicsCertificateFilenamePresent && form.status != ''">NICS EZCheck</div>
                    <div class="primary button spaced col-2" @click="nicsEZCheck = true" v-else-if="enicsCertificateFilenamePresent">NICS EZCheck</div>
                </template>
                <template v-else>
                    <div class="primary button disabled spaced">NICS Online Check</div>
                    <div class="primary button disabled spaced col-2">NICS Phone Check</div>
                    <div class="primary button disabled spaced" v-if="enicsCertificateFilenamePresent">NICS EZCheck</div>
                </template>
            </div>

            <div class="form-line two-columns">
                <div class="label">
                    27.a. Date the transferee’s/buyer’s identifying information in Section B was transmitted to NICS or the appropriate State agency:
                    <changes :changeLog="changeLog['section_c.nics_initial_response_date']" v-if="changeLog['section_c.nics_initial_response_date']"></changes>
                </div>
                <div class="label">
                    27.b. The NICS or State transaction number <em>(if provided)</em> was:
                    <changes :changeLog="changeLog['nics_number']" v-if="changeLog['nics_number']"></changes>
                </div>
                <date-input :disabled="statusCodes.E_COMPLETE" :class="{ error: signedDateError }" ref="nics_initial_response_date" v-model="form.form_data.section_c.nics_initial_response_date" key="date_nics_initial_response_date"></date-input>
                <input :disabled="statusCodes.E_COMPLETE" name="nics_number" class="column-two" ref="form_nics_number" v-model="form.nics_number" type="text" >
            </div>
            <div class="help-box-outer form-line">
                <div :class="['help-box-label', showHelp.indexOf(27) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(27)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(27) > -1">
                    <p>Question 27. NICS Background Checks: 18 U.S.C. 922(t) requires that prior to transferring any firearm to an unlicensed person, a licensed importer, manufacturer, or dealer must first contact the National Instant Criminal Background Check System (NICS). NICS will advise the licensee whether the system finds any information that the purchaser is prohibited by law from possessing or receiving a firearm. For purposes of this form, contacts to NICS include State agencies designated as points-of-contact (or POCs) to conduct NICS checks for the Federal Government.</p>
                    <p>The licensee should NOT contact NICS and must stop the transaction if there is reasonable cause to believe that the transferee/buyer is prohibited from receiving or possessing a firearm, including if: the transferee/buyer answered "no" to question 21.a.; the transferee/buyer answered "yes" to any question in 21.b. - 21.k.; the transferee/ buyer answered "yes" to question 21.l.1., and answered "no" to question 21.l.2.; or the transferee/buyer cannot provide the documentation required by questions 26.a, b, c, or d. Warning: Any person who transfers a firearm to any person he/she knows or has reasonable cause to believe is prohibited from receiving or possessing a firearm violates the law, 18 U.S.C. 922(d), even if the transferor/seller has complied with the Federal background check requirements.</p>
                    <p>NICS Responses: If NICS provides a "proceed" response, the transaction may proceed. If NICS provides a "denied" or "cancelled" (and does not immediately provide a new transaction number) response, the transferor/seller is prohibited from transferring the firearm to the transferee/buyer. If NICS provides a "delayed" response, the transferor/seller is prohibited from transferring the firearm unless
                    3 business days have elapsed and, before the transfer, NICS or the State has not advised the transferor/seller that the transferee's/buyer's receipt or possession of the firearm would be in violation of law. (See 27 CFR 478.102(a) for an example of how to calculate 3 business days.) If NICS provides a "delayed" response, NICS also will provide a Missing Disposition Information (MDI) date that calculates the 3 business days and reflects when the firearm(s) can be transferred under Federal law. States may not provide an MDI date. Some States may not provide a transaction number for denials. However, if a firearm is transferred within the three business day period, a transaction number is required. State law may impose a waiting period or other requirements on transferring firearms.</p>
                    <p>At the time that NICS is contacted, the licensee must record in question 27.a. - 27.c.: the date of contact, the NICS (or State) transaction number, and the initial response provided by NICS or the State. The licensee may record the date the firearms may be transferred to the transferee/buyer (also known as the Missing Disposition Information (MDI) date) in 27.c. that NICS provides for delayed transactions (States may not provide this date). If the licensee receives any subsequent response(s) before transferring the firearm, the licensee must record in question 27.d. any response later provided by NICS or the State, or that no response was provided within 3 business days. If the licensee receives a response from NICS or the State after the firearm has been transferred, he/she must record this information in question 27.e. If the transaction was denied and later overturned, in addition to checking the "Proceed" in 27.d. and entering the date, the licensee must also check "Overturned" and, if provided, attach the overturn certificate issued by NICS or the State POC to this ATF Form 4473. If more than 30 days have elapsed and a new NICS check is required, record the new transaction number, date of contact and the response provided by NICS or the State on this Form 4473 in questions 27.a.-27.c. Note: States acting as points of contact for NICS checks may use terms other than "proceed," "delayed," "cancelled," or "denied." In such cases, the licensee should check the box that corresponds to the State's response.</p>
                </div>
            </div>

            <div class="form-line label nics-researching" v-if="form.status == 'NICS_RESEARCHING'">
                <i class="fas fa-info-circle"></i>
                <span>The status of the NTN is "researching". We will continue to check the status and will update the form once we receive a status other than "researching".</span>
            </div>

            <div class="form-line label">
                27.c. The response initially provided by NICS or the appropriate State agency was:
                <changes :changeLog="changeLog['section_c.nics_initial_response']" v-if="changeLog['section_c.nics_initial_response']"></changes>
            </div>
            <div class="form-line nics-initial-response">
                <label class="radio first"><input :disabled="statusCodes.E_COMPLETE" type="radio" v-model="form.form_data.section_c.nics_initial_response" name="nics_initial_response" id="nics_status_proceed" value="Proceed"><span :class="['proceed', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Proceed</span></label>
				<label class="radio"><input :disabled="statusCodes.E_COMPLETE" type="radio" v-model="form.form_data.section_c.nics_initial_response" name="nics_initial_response" id="nics_status_denied" value="Denied"><span :class="['denied', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Denied</span></label>
				<label class="radio"><input :disabled="statusCodes.E_COMPLETE" type="radio" v-model="form.form_data.section_c.nics_initial_response" name="nics_initial_response" id="nics_status_delayed" value="Delayed"><span :class="['delayed', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Delayed</span></label>
				<label class="radio last"><input :disabled="statusCodes.E_COMPLETE" type="radio" v-model="form.form_data.section_c.nics_initial_response" name="nics_initial_response" id="nics_status_cancelled" value="Cancelled"><span :class="['cancelled', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Cancelled</span></label>
				<label class="grid three-columns">
                    <changes :changeLog="changeLog['section_c.nics_firearm_may_be_transferred']" v-if="changeLog['section_c.nics_firearm_may_be_transferred']"></changes>
                    The firearm(s) may be transferred on
                    <date-input :disabled="statusCodes.E_COMPLETE" :allowFuture="true" :class="{ error: signedDateError }" v-model="form.form_data.section_c.nics_firearm_may_be_transferred" key="date_nics_firearm_may_be_transferred"></date-input>
                    if State law permits (optional)
                </label>
            </div>
            <div class="form-line label">27.d. Prior to transfer the following response(s) was/were later provided by NICS or the appropriate State agency:
                <label class="changes" v-if="Object.keys($findKeyInObj('nics_later_response_', changeLog)).length > 0">
                    <input type="checkbox">
                    <span class="initials">{{ changeLog['user_initials'] }}</span>
                    <div class="change-list">
                        <div class="log-time">{{ $moment(changeLog.log_time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm') }}</div>
                        <div class="old-value two-columns" v-if="changeLog['section_c.nics_later_response_proceed']">
                        <span>Proceed: {{ changeLog['section_c.nics_later_response_proceed'].old_value ? 'true' : 'false' }}</span>
                        <span>Date: {{ changeLog['section_c.nics_later_response_proceed_date'].old_value ? changeLog['section_c.nics_later_response_proceed_date'].old_value : 'BLANK' }}</span>
                        </div>
                        <div class="old-value two-columns" v-if="changeLog['section_c.nics_later_response_denied']">
                        <span>Denied: {{ changeLog['section_c.nics_later_response_denied'].old_value ? 'true' : 'false' }}</span>
                        <span>Date: {{ changeLog['section_c.nics_later_response_denied_date'].old_value ? changeLog['section_c.nics_later_response_denied_date'].old_value : 'BLANK' }}</span>
                        </div>
                        <div class="old-value two-columns" v-if="changeLog['section_c.nics_later_response_cancelled']">
                        <span>Cancelled: {{ changeLog['section_c.nics_later_response_cancelled'].old_value ? 'true' : 'false' }}</span>
                        <span>Date: {{ changeLog['section_c.nics_later_response_cancelled_date'].old_value ? changeLog['section_c.nics_later_response_cancelled_date'].old_value : 'BLANK' }}</span>
                        </div>
                        <div class="old-value" v-if="changeLog['section_c.nics_later_response_no_response']">
                        <span>No response: {{ changeLog['section_c.nics_later_response_no_response'].old_value ? 'true' : 'false' }}</span>

                        </div>
                        <div class="old-value" v-if="changeLog['section_c.nics_later_response_overturned']">
                        <span>Overturned: {{ changeLog['section_c.nics_later_response_overturned'].old_value ? 'true' : 'false' }}</span>

                        </div>
                    </div>
                </label>
            </div>
            <div class="form-line nics-later-response three-columns">
                <div class="two-columns">
                    <label class="checkbox">
                        <input :disabled="statusCodes.E_COMPLETE" type="checkbox" id="nics_later_response_proceed" v-model="form.form_data.section_c.nics_later_response_proceed">
                        <span :class="['proceed', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Proceed</span>
                    </label>
                    <date-input :disabled="statusCodes.E_COMPLETE" :allowFuture="true" :class="{ error: signedDateError }" v-model="form.form_data.section_c.nics_later_response_proceed_date" key="date_nics_later_response_proceed_date"></date-input>
                </div>
				<div class="two-columns">
                    <label class="checkbox">
                        <input :disabled="statusCodes.E_COMPLETE" type="checkbox" id="nics_later_response_denied" v-model="form.form_data.section_c.nics_later_response_denied">
                        <span :class="['denied', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Denied</span>
                    </label>
                    <date-input :disabled="statusCodes.E_COMPLETE" :allowFuture="true" :class="{ error: signedDateError }" v-model="form.form_data.section_c.nics_later_response_denied_date" key="date_nics_later_response_denied_date"></date-input>
                </div>
				<div class="two-columns">
                    <label class="checkbox">
                        <input :disabled="statusCodes.E_COMPLETE" type="checkbox" id="nics_later_response_cancelled" v-model="form.form_data.section_c.nics_later_response_cancelled">
                        <span :class="['cancelled', {disabled: statusCodes.E_COMPLETE}]"><i class="fas fa-check-circle"></i>Cancelled</span>
                    </label>
                    <date-input :disabled="statusCodes.E_COMPLETE" :allowFuture="true" :class="{ error: signedDateError }" v-model="form.form_data.section_c.nics_later_response_cancelled_date" key="date_nics_later_response_cancelled_date"></date-input>
                </div>
				<div class="span-two">
                    <label class="checkbox">
    					<input :disabled="statusCodes.E_COMPLETE" :allowFuture="true" type="checkbox" id="nics_later_response_no_response" v-model="form.form_data.section_c.nics_later_response_no_response">
    					<span :class="['span-two', {disabled: statusCodes.E_COMPLETE}]">
    						<i class="fas fa-check-circle"></i>
    						No response was provided within 3 business days.
    					</span>
    				</label>
    				<label class="checkbox">
    					<input :disabled="statusCodes.E_COMPLETE" type="checkbox" id="nics_later_response_overturned" v-model="form.form_data.section_c.nics_later_response_overturned">
    					<span :class="{disabled: statusCodes.E_COMPLETE}"><i class="fas fa-check-circle"></i>Overturned</span>
    				</label>
                </div>
            </div>
            <div class="form-line label">27.e. After the firearm was transferred, the following response was provided by NICS or the appropriate State agency (if applicable) on:</div>
            <div class="form-line one-three-columns">
                <date-input :class="{ error: signedDateError }" :allowFuture="true" v-model="form.form_data.section_c.nics_after_transfer_response_date" key="date_nics_after_transfer_response_date"></date-input>
                <div>
                    <label class="radio first">
                        <input type="radio" @click="form.form_data.section_c.nics_after_transfer_response = !form.form_data.section_c.nics_after_transfer_response" v-model="form.form_data.section_c.nics_after_transfer_response" value="Proceed">
                        <span class="proceed"><i class="fas fa-check-circle"></i>Proceed</span>
                    </label>
                    <label class="radio">
                        <input type="radio" @click="form.form_data.section_c.nics_after_transfer_response = !form.form_data.section_c.nics_after_transfer_response" v-model="form.form_data.section_c.nics_after_transfer_response" value="Denied">
                        <span class="denied"><i class="fas fa-check-circle"></i>Denied</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" @click="form.form_data.section_c.nics_after_transfer_response = !form.form_data.section_c.nics_after_transfer_response" v-model="form.form_data.section_c.nics_after_transfer_response" value="Cancelled">
                        <span class="cancelled"><i class="fas fa-check-circle"></i>Cancelled</span>
                    </label>
                    <button v-if="userCanEdit && statusCodes.E_COMPLETE" style="margin: 0 0 0 2em;" class="button action inline" @click="forceSaveForm()">Save 27.e</button>
                </div>
            </div>
            <div class="form-line two-columns">
                <div class="two-columns">
                    <div class="span-two">27.f. Name and Brady identification number of the NICS examiner. <div class="small">(optional)</div></div>
                    <label>
                        <changes :changeLog="changeLog['section_c.nics_examiner_name']" v-if="changeLog['section_c.nics_examiner_name']"></changes>
                        <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.nics_examiner_name"><div class="small text-align-center">(Name)</div>
                    </label>
                    <label>
                        <changes :changeLog="changeLog['section_c.nics_examiner_brady_number']" v-if="changeLog['section_c.nics_examiner_brady_number']"></changes>
                        <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.nics_examiner_brady_number"><div class="small text-align-center">(Number)</div>
                    </label>
                </div>
                <label>27.g. Name of FFL Employee Completing NICS check. <div class="small">(optional)</div>
                    <changes :changeLog="changeLog['section_c.employee_completing_nics']" v-if="changeLog['section_c.employee_completing_nics']"></changes>
                    <input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.employee_completing_nics">
                </label>
            </div>
            <div class="form-line nics-buyer-background-check position-relative">
                <changes :changeLog="changeLog['section_c.nics_buyer_background_check']" v-if="changeLog['section_c.nics_buyer_background_check']"></changes>
                <div>28.</div>
                <label class="checkbox with-outside-label">
					<input :disabled="statusCodes.E_COMPLETE" type="checkbox" id="nics_buyer_background_check" v-model="form.form_data.section_c.nics_buyer_background_check">
					<span :class="{disabled: statusCodes.E_COMPLETE}"><i class="fas fa-check-circle"></i></span>
                    <span class="label-text">No NICS check is required because a background check was completed during the NFA approval process on the individual who will receive the NFA firearm(s), as reflected on the approved NFA application.</span>
				</label>
            </div>
            <div class="form-line nics-buyer-background-check position-relative">
                <changes :changeLog="changeLog['section_c.nics_buyer_exempt']" v-if="changeLog['section_c.nics_buyer_exempt']"></changes>
                <div>29.</div>
                <label class="checkbox with-outside-label">
                    <input :disabled="statusCodes.E_COMPLETE" type="checkbox" id="nics_buyer_exempt" v-model="form.form_data.section_c.nics_buyer_exempt">
                    <span :class="{disabled: statusCodes.E_COMPLETE}"><i class="fas fa-check-circle"></i></span>
                    <span class="label-text">No NICS check is required because the transferee/buyer has a valid permit from the State where the transfer is to take place, which qualifies as an exemption to NICS.</span>
                </label>
            </div>
            <div class="form-line four-columns">
				<label>Issuing State and Permit Type
                    <changes :changeLog="changeLog['section_c.nics_buyer_exempt_permit_state_type']" v-if="changeLog['section_c.nics_buyer_exempt_permit_state_type']"></changes>
					<input type="text" :disabled="statusCodes.E_COMPLETE" v-model="form.form_data.section_c.nics_buyer_exempt_permit_state_type">
				</label>
				<label>Date of Issuance (if any)
                    <changes :changeLog="changeLog['section_c.nics_buyer_exempt_permit_date_issuance']" v-if="changeLog['section_c.nics_buyer_exempt_permit_date_issuance']"></changes>
                    <date-input :disabled="statusCodes.E_COMPLETE" :allowFuture="false" v-model="form.form_data.section_c.nics_buyer_exempt_permit_date_issuance" key="date_nics_buyer_exempt_permit_date_issuance"></date-input>
                </label>
				<label>Expiration Date (if any)
                    <changes :changeLog="changeLog['section_c.nics_buyer_exempt_permit_date_expiration']" v-if="changeLog['section_c.nics_buyer_exempt_permit_date_expiration']"></changes>
                    <date-input :disabled="statusCodes.E_COMPLETE" :allowFuture="true" :allowPast="true" v-model="form.form_data.section_c.nics_buyer_exempt_permit_date_expiration" key="date_nics_buyer_exempt_permit_date_expiration"></date-input>
                </label>
				<label>Permit Number (if any)
                    <changes :changeLog="changeLog['section_c.nics_buyer_exempt_permit_number']" v-if="changeLog['section_c.nics_buyer_exempt_permit_number']"></changes>
					<input :disabled="statusCodes.E_COMPLETE" type="text" v-model="form.form_data.section_c.nics_buyer_exempt_permit_number">
                </label>
            </div>
            <div class="help-box-outer form-half">
				<div :class="['help-box-label', showHelp.indexOf(28) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(28)"><i class="fas fa-info"></i></div>
				<div class="help-box"  v-show="showHelp.indexOf(28) > -1">
					<p>Questions 28 and 29. NICS Exceptions: A NICS check is not required if the transfer qualifies for any of the exceptions in 27 CFR 478.102(d). Generally these include: (a) transfers of National Firearms Act firearms to an individual who has undergone a background check during the NFA approval process; (b) transfers where the transferee/buyer has presented the licensee with a permit or license that allows the transferee/buyer to possess, acquire, or carry a firearm, and the permit has been recognized by ATF as a valid alternative to the NICS check requirement; or (c) transfers certified by ATF as exempt because compliance with the NICS check requirements is impracticable. If the transfer qualifies for one of these exceptions, the licensee must obtain the documentation required by 27 CFR 478.131. A firearm must not be transferred to any transferee/buyer who fails to provide such documentation.</p>
                    <p>A NICS check must be conducted if an NFA firearm has been approved for transfer to a trust, or to a legal entity such as a corporation, and no background check was conducted as part of the NFA approval process on the individual who will receive the firearm. Individuals who have undergone a background check during the NFA application process are listed on the approved NFA transfer form.</p>
				</div>
			</div>
        </div>

        <!-- /.section-c -->
        <div class="form section-d list dealer-form" v-if="formSection == 'section_d'" ref="section_top">
            <h2 class="section-title">Section D - Must Be Completed Personally By Transferee/Buyer</h2>
            <div class="form-line">If the transfer of the firearm(s) takes place on a different day from the date that the transferee/buyer signed Section B, the transferee/buyer must complete Section D immediately prior to the transfer of the firearm(s).</div>
            <div class="form-line"><strong>I certify that all of my responses in Section B of this form are still true, correct, and complete.</strong></div>
            <div class="form-line three-one-columns">
                <div>
                    <label>30. Transferee’s/Buyer’s Signature</label>
                    <div class="signature-group" v-if="form.form_data && form.form_data.section_d.buyer_recertification_signature">
                        <img class="signature" :src="form.form_data.section_d.buyer_recertification_signature" alt="">
                    </div>
                </div>
                <div>
                    <div class="label">31. Recertification Date</div>
                    <date-input :disabled="true" :class="{ error: signedDateError }" :allowFuture="true" v-model="form.form_data.section_d.buyer_recertification_date" key="date_buyer_recertification_date"></date-input>
                </div>
            </div>
            <div class="help-box-outer form-half">
				<div :class="['help-box-label', showHelp.indexOf(30) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(30)"><i class="fas fa-info"></i></div>
				<div class="help-box"  v-show="showHelp.indexOf(30) > -1">
					Questions 30 and 31. Transfer on a Different Day and Recertification: If the transfer takes place on a different day from the date that the transferee/buyer signed Section B, the licensee must again check the photo identification of the transferee/ buyer at the time of transfer.
				</div>
			</div>
        </div>
        <!-- /.section-d -->

        <div class="form section-e list dealer-form" v-if="formSection == 'section_e'">
            <h2 class="section-title">Section E - Must Be Completed By Transferor/Seller</h2>
            <div class="form-line two-columns">
                <div style="width:100%;">
                    <label for="seller_notes">32. For Use by Licensee</label>
                    <textarea name="seller_notes" v-model="form.form_data.section_e.seller_notes" :disabled="capturingSignature"></textarea>
                    <button v-if="userCanEdit" style="margin: 0;" class="button action inline" @click="forceSaveForm()">Save 32.</button>
                </div>
                <div>
                    <label for="dealer_address">33. Trade/corporate name and address of transferor/seller and Federal Firearm License Number (must contain at least first three and last five digits X-XX-XXXXX; hand stamp may be used)
                        <changes :changeLog="changeLog['section_e.seller_name_address_ffl']" v-if="changeLog['section_e.seller_name_address_ffl']"></changes>
                    </label>
					<textarea :disabled="statusCodes.E_COMPLETE || capturingSignature" class="dealer-address" name="dealer_address" v-model="form.form_data.section_e.seller_name_address_ffl" rows="15"></textarea>
                </div>
            </div>
            <div class="help-box-outer form-half">
				<div :class="['help-box-label', showHelp.indexOf(32) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(32)"><i class="fas fa-info"></i></div>
				<div class="help-box"  v-show="showHelp.indexOf(32) > -1">
					Question 32. For Use by Licensee: This item is for the licensee's use in recording any information he/she finds necessary to conduct business or any additional information received from NICS that is not recorded in Questions 27.a. - 27.e.
				</div>
			</div>
            <div class="form-line"><strong>The Individual Transferring The Firearm(s) Must Complete Questions 34-36. For Denied/Cancelled Transactions, The Individual Who Completed Section C Must Complete Questions 34-35</strong></div>
            <div class="form-line"><strong>I certify that: (1) I have read and understand the Notices, Instructions, and Definitions on this ATF Form 4473; (2) the information recorded in Sections A, C and E is true, correct, and complete; and (3) this entire transaction record has been completed at the licensed business premises (“licensed premises” includes business temporarily conducted from a qualifying gun show or event in the same State in which the licensed premises is located) unless this transaction has met the requirements of 18 U.S.C. 922(c). Unless this transaction has been denied or cancelled by NICS or State agency, I further certify on the basis of — (1) the transferee’s/buyer’s responses in Section B (and Section D, if applicable); (2) the verification of the identification recorded in question 26 (and the re-verification at the time of transfer, if Section D was completed); and (3) State or local law applicable to the firearms business — it is my belief that it is not unlawful for me to sell, deliver, transport, or otherwise dispose of the firearm(s) listed on this form to the person identified in Section B. </strong></div>

            <div class="form-line">
				<label>34. Transferor's/Seller's Name (Please print)
                    <changes :changeLog="changeLog['section_e.seller_name']" v-if="changeLog['section_e.seller_name']"></changes>
                </label>
				<div>
					<input :disabled="statusCodes.E_COMPLETE || capturingSignature || !canSignSectionE" type="text" v-model="form.form_data.section_e.seller_name">
				</div>
            </div>

            <div class="form-line">

				<div v-if="!canSignSectionE" style="margin: 1em 0;">NICS Delayed response requires Section C, 27.d to be completed before signing.</div>

				<label>35. Transferor's/Seller's Signature</label>

                <div class="signature-group" v-if="form.form_data.section_e && form.form_data.section_e.seller_signature && !capturingSignature">
                    <img class="signature" :src="form.form_data.section_e.seller_signature" alt="">
                    <div class="cancel-signature" @click="captureSellerSignature()" v-if="!statusCodes.E_COMPLETE"><i class="fas fa-times"></i></div>
                </div>
                <div class="signature-group" v-else-if="capturingSignature">
                    <canvas id="seller_signature_pad" :width="signaturePadOnScreen ? 600 : 330" :height="signaturePadOnScreen ? 213 : 100"></canvas>
                    <div class="cancel-signature" @click="restoreSellersSignature"><i class="fas fa-times"></i></div>
                    <div class="controls" v-if="signaturePadOnScreen">
                        <div class="button action spaced" @click="saveSellerSignature()">Accept</div>
                        <div class="button neutral spaced" @click="clearCanvas()">Clear</div>
                        <button class="button neutral spaced" @click="captureSellerSignature()">Switch to Signature Pad</button>
                    </div>
                    <div class="controls" v-else>
                        <button class="button action" @click="captureSellerSignature(true)">Switch to on Screen</button>
                    </div>
                </div>
                <div class="signature" v-else-if="userCanEdit && !statusCodes.E_COMPLETE">
                    <button :class="['primary', canSignSectionE ? 'button' : 'disabled']" @click="captureSellerSignature()">Connect to Signature Pad</button>
                    <button v-if="canUseScreenCaptureSignature" :class="['primary', canSignSectionE ? 'button' : 'disabled']" style="margin: 0 0 0 1em;" @click="captureSellerSignature(true)">Sign on Screen</button>
                </div>
            </div>

            <div class="form-line">
				<label style="width: 50%;">36. Date Transferred
                    <changes :changeLog="changeLog['section_e.transfer_date']" v-if="changeLog['section_e.transfer_date']"></changes>
                </label>
				<div class="two-columns position-relative">
                    <date-input :disabled="statusCodes.E_COMPLETE || !canSignSectionE" :class="{ error: signedDateError }" v-model="form.form_data.section_e.transfer_date" key="date_transfer_date"></date-input>
					<label class="checkbox with-outside-label">
                         <input :disabled="statusCodes.E_COMPLETE" type="checkbox" id="nics_buyer_exempt" v-model="form.form_data.section_e.not_transferred" @click="toggleNotTransferred()">
                         <span :class="{disabled: statusCodes.E_COMPLETE}"><i class="fas fa-check-circle"></i></span>
                         <span class="label-text">&nbsp; Not Transferred</span>
                     </label>
                     <changes :changeLog="changeLog['section_e.not_transferred']" v-if="changeLog['section_e.not_transferred']"></changes>
				</div>
			</div>

            <div class="help-box-outer form-half">
                <div :class="['help-box-label', showHelp.indexOf('form') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('form')"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf('form') > -1">
                    <p>Privacy Act Information</p>
                    <p>Solicitation of this information is authorized under 18 U.S.C. 923(g) and 922(b)(5). Disclosure of this information by the transferee/buyer is mandatory for the transfer of a firearm. Disclosure of the individual's Social Security number is voluntary. The number may be used to verify the transferee's/buyer's identity.</p>
                    <p>For information about the routine uses of this form see System of Records Notice Justice/ATF- 008, Regulatory Enforcement Records System (68 FR 163558, January 24, 2003).</p>
                    <p>Paperwork Reduction Act Notice</p>
                    <p>The information required on this form is in accordance with the Paperwork Reduction Act of 1995. The purpose of the information is to determine the eligibility of the transferee to receive and possess firearms under Federal law. The information is subject to inspection by ATF officers and is required by 18 U.S.C. 922 and 923.</p>
                    <p>The estimated average burden associated with this collection is 30 minutes per respondent or recordkeeper, depending on individual circumstances. Comments about the accuracy of this burden estimate and suggestions for reducing it should be directed to Reports Management Officer, IT Coordination Staff, Bureau of Alcohol, Tobacco, Firearms and Explosives, Washington, DC 20226.</p>
                    <p>An agency may not conduct or sponsor, and a person is not required to respond to, a collection of information unless it displays a currently valid OMB control number. Confidentiality is not assured.</p>
                </div>
            </div>
        </div>
        <!-- /.section-e -->

    </div>

    <div class="transaction-purpose modal" v-else-if="nicsOnlineCheck && !(continueCheck && customerTransPurposeSet)">
		<div class="inner">
			<h2>Transaction Purpose</h2>
			<div class="content">
				<label><input type="checkbox" v-model="customerTransPurpose.l1">Sale of hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l2">Sale of long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l3">Sale of other (Frame, Receiver, etc.)</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l5">Pre-pawn of hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l6">Pre-pawn of long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l7">Pre-pawn of other (Frame, Receiver, etc.)</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l9">Redemption of hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l10">Redemption of long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l11">Redemption of other (Frame, Receiver, etc.)</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l27">Private Sale hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l28">Private Sale Long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l29">Private Sale Other</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l30">Private Sale Returned to Seller Hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l31">Private Sale Returned to Seller Long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l32">Private Sale Returned to Seller Other</label>
			</div>

			<div class="controls">
				<div v-if="customerTransPurposeSet" style="margin: 1em 0 0 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
					<img src="@/assets/img/warning-icon.png" style="width: 3.25em;">
					<div style="text-align: left; line-height: 1.5em;">
						Click CONTINUE to open the FBI NICS website in a new window, then...<br>
						1) Log in using your LEEP username and password.<br>
						2) Click "Submit a Search Request - E.C." and check "Yes" in the FFL Verification section.<br>
						4) Use the TRANSFER 4473 DATA button at the top of the LEEP site to copy data on each screen.<br>
						5) Use the COPY RESPONSE button at the top of the LEEP site to record the NICS response.<br>
						6) Then, come <b>back to this window</b> to add the NICS response to this 4473.
					</div>
				</div>
				<div class="cancel button spaced" @click="nicsOnlineCheck = continueCheck = false">Cancel</div>
				<div class="primary button spaced" @click="handleFillNicsForm()" v-if="customerTransPurposeSet">Continue</div>
				<div class="primary button disabled spaced" v-else>Continue</div>
			</div>
		</div>
	</div>

    <div class="transaction-purpose modal" v-if="nicsEZCheck">
		<div class="inner" v-if="!nicsEZCheckComplete && !nicsEZCheckInProgress">
			<h2>Transaction Purpose</h2>
			<div class="content">
                <!-- See transactionPurposes computed property below for explanation -->
				<!-- <label v-for="(purpose, id) in transactionPurposes"><input type="checkbox">{{ purpose }}</label> -->
				<label><input type="checkbox" v-model="customerTransPurpose.l1">Sale of hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l2">Sale of long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l3">Sale of other (Frame, Receiver, etc.)</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l5">Pre-pawn of hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l6">Pre-pawn of long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l7">Pre-pawn of other (Frame, Receiver, etc.)</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l9">Redemption of hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l10">Redemption of long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l11">Redemption of other (Frame, Receiver, etc.)</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l27">Private Sale hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l28">Private Sale Long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l29">Private Sale Other</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l30">Private Sale Returned to Seller Hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l31">Private Sale Returned to Seller Long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l32">Private Sale Returned to Seller Other</label>
			</div>

            <div class="contact-form">
                    <div class="label">Contact First Name</div>
                    <input type="text" v-model="nicsContactFirstName">
                    <div class="label">Contact Last Name</div>
                    <input type="text" v-model="nicsContactLastName">
                    <div class="label">Contact Phone Number</div>
                    <input type="text" v-model="nicsContactPhoneNumber">
                    <div class="label">Contact LEEP User ID</div>
                    <input type="text" v-model="nicsContactLeepUserId">
                </div>

			<div class="controls">
				<div class="cancel button spaced" @click="nicsEZCheck = false">Cancel</div>
				<div class="primary button spaced" @click="doNicsEZCheck()" v-if="customerTransPurposeSet">Do NICS EZCheck</div>
				<div class="primary button disabled spaced" v-else>Do NICS EZCheck</div>
			</div>
		</div>
        <div class="inner" v-else-if="nicsEZCheckInProgress">
            <h2>NICS EZCheck in Progress</h2>
            <div class="content in-progress">
                <loading>Contacting the EZCheck servers now. This could take several seconds depending on network traffic. Please do not refresh or navigate away at this time.</loading>
            </div>
        </div>
        <div class="inner" v-else-if="nicsEZCheckComplete && nicsEZCheckError">
            <h2>NICS EZCheck Error</h2>
            <div class="content complete">
                <p class="span-two">EZCheck returned the following error:</p>
                <p class="span-two" v-if="nicsEZCheckErrorMessage.indexOf('Internal Error') == -1">{{ nicsEZCheckErrorMessage }}</p>
                <p class="span-two" v-else>Something went wrong, please contact customer support and mention the following error code: NICS_INTERNAL_ERROR.</p>
            </div>
            <div class="controls">
				<div class="primary button" @click="nicsEZCheck = nicsEZCheckError = nicsEZCheckComplete = false">OK</div>
			</div>
        </div>
        <div class="inner" v-else-if="nicsEZCheckComplete && !nicsEZCheckResearchingResponse">
            <h2>NICS EZCheck Complete</h2>
            <div class="content complete">
                <p class="span-two">The following response was returned from the NICS EZCheck. These values have already been entered in the form.</p>
                <div class="nics-form-result">
                    <div class="label">
                        Date
                    </div>
                    <date-input class="column-two" :class="{ error: signedDateError }" ref="nics_initial_response_date" v-model="form.form_data.section_c.nics_initial_response_date" key="date_nics_initial_response_date"></date-input>
                    <div class="label">
                        NICS number
                    </div>
                    <input class="column-two" ref="form_nics_number" v-model="form.nics_number" type="text">
                    <div class="form-line label">
                        Initial response
                    </div>
                    <input class="column-two" ref="form_nics_number_initial_response" v-model="form.form_data.section_c.nics_initial_response" type="text">
                    <div class="label span-two" v-if="form.form_data.section_c.nics_initial_response == 'Delayed'">
                        The firearm(s) may be transferred on
                        <date-input :allowFuture="true" :class="{ error: signedDateError }" v-model="form.form_data.section_c.nics_firearm_may_be_transferred" key="date_nics_firearm_may_be_transferred"></date-input>
                        if State law permits (optional)
                    </div>
                </div>
            </div>
            <div class="controls">
				<div class="primary button" @click="nicsEZCheck = nicsEZCheckComplete = false">OK</div>
			</div>
        </div>
        <div class="inner" v-else-if="nicsEZCheckResearchingResponse">
            <h2>NICS EZCheck Complete</h2>
            <div class="content complete">
                <p class="span-two">The response was "researching". The NICS Number and Brady transfer date have been recorded in the form.</p>
                <p class="span-two">We will continue to check the status and will update the form once we receive a status other than "researching".</p>
                <div class="nics-form-result">
                    <div class="label">
                        NICS number
                    </div>
                    <input class="column-two" ref="form_nics_number" v-model="form.nics_number" type="text">
                    <div class="label span-two three-columns">
                        The firearm(s) may be transferred on
                        <date-input :allowFuture="true" :class="{ error: signedDateError }" v-model="form.form_data.section_c.nics_firearm_may_be_transferred" key="date_nics_firearm_may_be_transferred"></date-input>
                        if State law permits
                    </div>
                </div>
            </div>
            <div class="controls">
				<div class="primary button" @click="nicsEZCheck = nicsEZCheck = false">OK</div>
			</div>
        </div>
	</div>

	<div class="nics-online-check" v-if="false">

		<h1>NICS Online Check</h1>

		<!-- <iframe :src="cjisIframeUrl" frameborder="0"></iframe> -->

		<div class="controls">

			<div style="margin: 1em 0 0 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
				<img src="@/assets/img/warning-icon.png" style="width: 3.25em;">
				<div style="text-align: left; line-height: 1.5em;">
					On the FBI NICS page, did you...<br>
					1) Log in using your LEEP username and password?<br>
					2) Click "Submit a Search Request - E.C."?<br>
					3) Check "Yes" in the FFL Verification section?<br>
					<!-- 4) Click "Revision Date May 2020" for the ATF Form Version?<br> -->
					If so, click the FILL THE FORM button to send info from this 4473 to the FBI NICS form.<br>
				</div>
			</div>

			<div class="button primary" @click="handleFillNicsForm()">Fill the Form</div>

			<div v-if="fillNicsFormChecked" style="margin: 1em 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
				<img src="@/assets/img/warning-icon.png" style="width: 3.25em;">
				<div style="text-align: left; line-height: 1.5em;">
					Info from this 4473 should now be on the FBI NICS page.<br>
					Remember, you are soley responsible for the accuracy of your submission.<br>
					Please check all fields carefully before submitting your NICS check.<br>
					After submitting your NICS check, come <b>back to this window</b> where you should see the NTN Number and Initial Response.<br>
				</div>
			</div>

			<div class="nics-form-result" style="margin: 1em 0;">
				<label>NTN Number</label>
				<label>Initial Response</label>
				<input id="nics_number" ref="modal_nics_number" type="text">
				<input id="nics_initial_response" ref="modal_nics_initial_response" type="text">
			</div>

			<div v-if="fillNicsFormChecked">
				Don't see the NTN Number and Initial Response? You can copy and paste them from the FBI NICS page.
			</div>

			<div class="button cancel" @click="nicsOnlineCheck = continueCheck = false; scrollToNTN()">Cancel</div>
			<div class="button primary" @click="saveOnlineNTNStatus">Continue</div>
		</div>
	</div>

    <div class="transaction-purpose modal" v-if="nicsPhoneCheck && !(continueCheck && customerTransPurposeSet)">
        <div class="inner">
            <h2>Transaction Purpose</h2>
            <div class="content">
                <label><input type="checkbox" v-model="customerTransPurpose.l1">Handgun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l2">Long Gun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l3">Other Firearm</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l4">Pre-pawn of hand gun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l5">Pre-pawn of long gun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l6">Pre-pawn of other</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l7">Redemption of hand gun </label>
                <label><input type="checkbox" v-model="customerTransPurpose.l8">Redemption of long gun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l9">Redemption of other</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l10">Private Sale hand gun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l11">Private Sale Long gun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l12">Private Sale Other</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l13">Private Sale Returned to Seller Hand gun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l14">Private Sale Returned to Seller Long gun</label>
                <label><input type="checkbox" v-model="customerTransPurpose.l15">Private Sale Returned to Seller Other</label>
            </div>

            <div class="controls">
                <div class="cancel button spaced" @click="nicsPhoneCheck = continueCheck = false">Cancel</div>
                <div class="primary button spaced" @click="continueCheck = true" v-if="customerTransPurposeSet">Continue</div>
                <div class="primary button disabled spaced" v-else>Continue</div>
            </div>
        </div>
    </div>

    <div class="nics-phone-check modal" v-else-if="nicsPhoneCheck">
        <div class="inner">
            <div class="content">

                <div v-if="forcingNICSPhoneCheck" style="grid-template-columns: 1fr;">
                    <p style="margin: 1em 0 0 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
                        <span><img src="@/assets/img/warning-icon.png" style="width: 3.25em;"/></span>
                        <span style="text-align: left; line-height: 1.5em;">
                            The FBI NICS website is currently experiencing an issue that prevents transferring info automatically.
                            Please manually enter the info below to perform the NICS Search Request.
                        </span>
                    </p>
                </div>

                <div class="small" style="float: right;">Scroll for all {{ forcingNICSPhoneCheck ? 'online' : 'phone' }} check info<br>and to enter result.</div>
                <h1>NICS {{ forcingNICSPhoneCheck ? 'Online' : 'Phone' }} Check</h1>

                <div><span>Customer Name</span> <span>{{ form.form_data.section_b.last_name }} {{ form.form_data.section_b.first_name }}</span></div>
                <div><span>First Name</span> <span>{{ form.form_data.section_b.first_name }}<template v-if="form.form_data.section_b.first_initial">   IO</template></span></div>
                <div><span>Last Name</span> <span>{{ form.form_data.section_b.last_name }}<template v-if="form.form_data.section_b.last_initial">   IO</template></span></div>
                <div><span>Middle Name</span> <span v-if="form.form_data.section_b.no_middle_name">NMN</span><span v-else>{{ form.form_data.section_b.middle_name }}<template v-if="form.form_data.section_b.middle_initial">   IO</template></span></div>
                <div><span>Height</span> <span>{{ form.form_data.section_b.feet }}'{{ form.form_data.section_b.inches }}''</span></div>
                <div><span>Weight</span> <span>{{ form.form_data.section_b.weight }}</span></div>
                <div><span>Gender</span> <span v-if="form.form_data.section_b.gender_code == 'U'">Non-Binary</span><span v-else>{{ form.form_data.section_b.gender_code }}</span></div>
                <div><span>Date of Birth</span> <span>{{ $moment(form.form_data.section_b.birthdate).format('MM/DD/YYYY') }}</span></div>
                <div>
                    <span>Place of Birth</span>
                    <span>{{ form.form_data.section_b.pob_code }}</span>
                </div>
                <div>
                    <span>Ethnicity</span> <span>{{ form.form_data.section_b.ethnicity }}</span>
                </div>
                <div>
                    <span>Race Code</span>
                    <!-- <ul class="customer-race-list"><li v-for="(race, index) in customerRaceCodes" :key="index">{{ race }}</li></ul> -->
                    <span class="ethnicity-list-item" v-if="form.form_data.section_b.customer_race.l4 != ''">American Indian or Alaskan Native</span>
                    <span class="ethnicity-list-item" v-if="form.form_data.section_b.customer_race.l2 != ''">Black or African American</span>
                    <span class="ethnicity-list-item" v-if="form.form_data.section_b.customer_race.l6 != ''">White</span>
                    <span class="ethnicity-list-item" v-if="form.form_data.section_b.customer_race.l1 != ''">Asian</span>
                    <span class="ethnicity-list-item" v-if="form.form_data.section_b.customer_race.l5 != ''">Native Hawaiian or Other Pacific Islander</span>
                </div>
                <div><span>State</span> <span>{{ form.form_data.section_b.state }}</span></div>
                <div>
                    <span>Citizenship</span>
                    <span v-if="form.form_data.section_b.citizen_status_code == 'C'">US Citizen</span>
                    <ul class="citizenship-country-list" v-else>
                        <li v-if="form.form_data.section_b.citizen_country_code">{{ form.form_data.section_b.citizen_country_code }}</li>
                        <li v-if="form.form_data.section_b.citizen_country_code_2">{{ form.form_data.section_b.citizen_country_code_2 }}</li>
                        <li v-if="form.form_data.section_b.citizen_country_code_3">{{ form.form_data.section_b.citizen_country_code_3 }}</li>
                    </ul>
                </div>
                <div><span>Social Security Number</span> <span>{{ form.form_data.section_b.ssn }}</span></div>
                <div>
                    <span>Transaction Purpose</span>
                    <ul class="transaction-purpose-list"><li v-for="(purpose, index) in customerTransPurposeList" :key="index">{{ purpose }}</li></ul>
                </div>

                <div style="margin: 0 2em; border-bottom: 0 none;">
                    <h3>NICS Response</h3><span></span>
                    <label>NTN Number</label> <input type="text" v-model="form.nics_number">
                    <label>FBI Status</label> <select v-model="form.form_data.section_c.nics_initial_response">
                        <option value="">Select one...</option>
                        <option value="Researching">Researching</option>
                        <option value="Proceed">Proceed</option>
                        <option value="Denied">Denied</option>
                        <option value="Delayed">Delayed</option>
                        <option value="Cancelled">Cancelled</option>
                    </select>
                    <!-- <label>Date</label> <date-input v-model="form.form_data.section_c.nics_initial_response_date"></date-input> -->
                    <label>Date</label> <input type="date" v-model="form.form_data.section_c.nics_initial_response_date"/>
                </div>
            </div>
            <div class="controls">
                <div class="button primary spaced" @click="handleNicsPhoneCheck">OK</div>
                <div class="button primary spaced" @click="nicsPhoneCheck = false">Cancel</div>
            </div>
        </div>
    </div>

    <div class="modal correction-warning" v-if="formCorrectWarning">
        <div class="inner" v-if="formCorrectErrors.length == 0">
            <h2>Confirm Move Form</h2>
            <div class="content">
                <p><strong>You are about to move this form. This can not be undone. A new form will be created with a link to the old one.</strong></p>
                <p>Are you sure you want to proceed?</p>
            </div>
            <div class="controls">
                <div class="button cancel spaced" @click="revertForm">Cancel</div>
                <div class="primary button spaced" @click="finishFormCorrect">Correct Form</div>
            </div>
        </div>
        <div class="inner" v-else>
            <h2>Correct Errors</h2>
            <div class="content">
                <strong>Please fix the following errors before proceeding.</strong><br>
                <strong>The following may not be blank:</strong>
                <ul class="form-errors">
                    <li v-for="(error, index) in formCorrectErrors" :key="'form-error-' + index">{{ error }}</li>
                </ul>
            </div>
            <div class="controls">
                <div class="button cancel" @click="formCorrectWarning = false">Cancel</div>
            </div>
        </div>
    </div>

    <div class="modal correction-warning" v-if="sectionBCorrectionDialog">
        <div class="inner">
            <h2>Confirm Correct Section B</h2>
            <div class="content">
                <p><strong>You are about to mark this form as needing correction in Section B. After you click "Confirm" you may proceed to the Customer 4473 form page and search for it there.</strong></p>
                <p>Are you sure you want to proceed?</p>
            </div>
            <div class="controls">
                <div class="button cancel spaced" @click="sectionBCorrectionDialog = false">Cancel</div>
                <div class="primary button spaced" @click="markFormForCorrection()">Confirm</div>
            </div>
        </div>
    </div>

    <div class="modal correction-warning" v-if="sectionDCorrectionDialog">
        <div class="inner">
            <h2>Confirm Correct Section D</h2>
            <div class="content">
                <p><strong>You are about to mark this form as needing correction in Section D. After you click "Confirm" you may proceed to the Customer 4473 form page and search for it there.</strong></p>
                <p>Are you sure you want to proceed?</p>
            </div>
            <div class="controls">
                <div class="button cancel spaced" @click="sectionDCorrectionDialog = false">Cancel</div>
                <div class="primary button spaced" @click="markFormForCorrection()">Confirm</div>
            </div>
        </div>
    </div>

    <div class="modal cancel-warning" v-if="cancellingForm">
        <div class="inner">
            <h2>Confirm {{ this.form.inactive ? 'Re-activate' : 'Cancel' }}</h2>
            <div class="content">
                <p><strong>You are about to {{ this.form.inactive ? 're-activate this form' : 'mark this form as cancelled' }}.</strong></p>
                <p v-if="!this.form.inactive">Cancelled forms aren't normally shown in your 4473 list, but you can filter for them as needed.</p>
                <p>Are you sure you want to proceed?</p>
            </div>
            <div class="controls">
                <div class="button cancel" @click="cancellingForm = false">No</div>
                <div class="primary button" @click="cancelForm()">Yes</div>
            </div>
        </div>
    </div>

    <div class="modal unsaved-changes-warning" v-if="unsavedChangesWarning">
        <div class="inner">
            <h2>Unsaved Changes</h2>
            <div class="content">
                <p><i class="fas fa-exclamation-triangle alert-icon"></i><strong>You have unsaved changes</strong></p>
                <p>Save your changes in {{ formSection.capitalizeWords() }} before viewing another section.</p>
            </div>
            <div class="controls">
                <div class="button cancel" @click="unsavedChangesWarning = false">Got It</div>
            </div>
        </div>
    </div>

    <div class="modal unsaved-changes-warning" v-if="missingSectionCWarning">
        <div class="inner">
            <h2>Section C Not Complete</h2>
            <div class="content">
                <p><i class="fas fa-exclamation-triangle alert-icon"></i><strong>Can't save as transferred</strong></p>
                <p>You cannot save Section E as transferred without first saving all appropriate Section C information.</p>
            </div>
            <div class="controls">
                <div class="button cancel" @click="missingSectionCWarning = false">Got It</div>
            </div>
        </div>
    </div>

    <div class="modal saving-final-section-warning" v-if="savingFinalSectionWarning">
        <div class="inner">
            <h2>Section E Reminder</h2>
            <div class="content">
                <p><i class="fas fa-exclamation-triangle alert-icon"></i><strong>Reminder</strong></p>
                <p>Once Section E is saved, you will not be able to make any further changes to Section C<span v-if="!sectionComplete('D')"> and your customer will not be able to complete Section D</span>.</p>
            </div>
            <div class="controls">
                <div class="button cancel spaced" @click="cancelSaveFinalSection()">Cancel</div>
                <div class="button primary spaced" @click="saveForm()">Save Section E</div>
            </div>
        </div>
    </div>

    <div class="modal signing-final-section-warning" v-if="sectionESignatureMessage">
        <div class="inner">
            <h2>This Form is not complete</h2>
            <div class="content">
                <p><i class="fas fa-exclamation-triangle alert-icon"></i><strong>Note</strong></p>
                <p>{{ sectionESignatureMessage }}</p>
            </div>
            <div class="controls">
                <div class="button cancel" @click="sectionESignatureMessage = ''">Got it!</div>
            </div>
        </div>
    </div>

    <div class="modal files-upload" v-if="filesUploadModalOpen">
        <div class="inner">
            <h2>Manage Attachments</h2>
            <div class="content">
                <em>Allowed file types: pdf, jpg, png, tiff, bmp</em>
                <div class="attach-files">
                    <vue-dropzone @vdropzone-file-added="filesFileAdded" @vdropzone-success="filesUploadSuccess" @vdropzone-error="filesUploadError" ref="filesDropzone" id="site_background_dropzone" :options="filesDropzoneOptions"></vue-dropzone>
                    <div class="uploaded-files dz-preview dz-file-preview"></div>
                </div>
                <transition name="fade">
                    <message :message="uploadMessage" v-if="uploadMessage" :block="true"></message>
                </transition>
                <div class="attached-files" v-if="fileReference.length > 0">
                    <span>Attached files</span>
                    <ul>
                        <li v-for="(file, index) in fileReference" :key="index">
                            <a class="clearfix" :href="generateAttachmentLink(file.ffl_log_book_form_attachment_id)" target="_blank"><span class="name">{{ file.file_name }}</span></a>
                            <span class="close-button" @click.prevent="confirmFileRemove = index"><i class="fa fa-times"></i></span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="controls">
                <div class="button cancel" @click="filesUploadModalOpen = false">Close</div>
                <span v-if="confirmFileRemove != null" style="padding: 0 0 0 2em;">Confirm remove?</span>
                <button v-if="confirmFileRemove != null" class="button delete" @click="removeFile()">Remove</button>
                <button v-if="confirmFileRemove != null" class="button cancel" @click="confirmFileRemove = null">Cancel</button>
            </div>
        </div>
    </div>

    <div class="modal generating-pdf" v-if="generatingPDF">
        <div class="inner" style="min-width: 27em;">
            <h2>Generating PDF</h2>
            <div class="content" style="text-align: center;">
                <p>{{ generatingPDFMessage }}</p>
                <p v-if="generatingPDFMessage.indexOf('ERROR') < 0" style="font-size: 1.5em;"><i class="fas fa-spinner fa-spin"></i></p>
            </div>
            <div class="controls">
                <div class="button cancel" @click="generatingPDF = false">Cancel</div>
            </div>
        </div>
    </div>

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

const TRANSACTION_PURPOSES = {
	l1: "Handgun",
	l2: "Long Gun",
	l3: "Other Firearm",
	l4: "Pre-pawn of hand gun",
	l5: "Pre-pawn of long gun",
	l6: "Pre-pawn of other",
	l7: "Redemption of hand gun ",
	l8: "Redemption of long gun",
	l9: "Redemption of other",
	l10: "Private Sale hand gun",
	l11: "Private Sale Long gun",
	l12: "Private Sale Other",
	l13: "Private Sale Returned to Seller Hand gun",
	l14: "Private Sale Returned to Seller Long gun",
	l15: "Private Sale Returned to Seller Other"
}
const CUSTOMER_RACE_CODES = {
	l4: "American Indian or Alaskan Native",
	l2: "Black or African American",
	l6: "White",
	l1: "Asian",
	l5: "Native Hawaiian or Other Pacific Islander"
}
import Form4473Changes from '../components/Form4473Changes'
import DateInput from '@/components/DateInput'
import SignaturePad from 'signature_pad'
import { mapState } from 'vuex'
export default {
    name: 'form4473-detail-electronic',
    props: ['id'],
    components: {
        'changes': Form4473Changes,
        'date-input': DateInput,
        'vue-dropzone': vue2Dropzone
    },
    data() {
        return {
            loading: true,
            clientHasVariance: false,
            showSavingForm: false,
            savingForm: false,
            saveError: false,
            search_customers: null,
            customers: [],
            customerSearchMessage: null,
            creatingContact: false,
            newContact: {
                first_name: '',
                middel_name: '',
                last_name: '',
                suffix: ''
            },
            newContactMessage: null,
            showingChangeLog: false,
            nicsOnlineCheck: false,
            forcingNICSPhoneCheck: false,
            nicsPhoneCheck: false,
            continueCheck: false,
            fillNicsFormChecked: false,
            formNumberMessage: 'Record a Transaction Serial Number',
            formSection: 'section_a',
            correctingForm: false,
            userInitials: '',
            formComplete: false,
            formCorrectWarning: false,
            formCorrectErrors: [],
            formSaveMessage: '',
            sectionBCorrectionDialog: false,
            sectionDCorrectionDialog: false,
            movedFromFFLLogBookFormId: '',
            customerTransPurpose: {
                l1: '',
                l2: '',
                l3: '',
                l4: '',
                l5: '',
                l6: '',
                l7: '',
                l8: '',
                l9: '',
                l10: '',
                l11: '',
                l12: '',
                l13: '',
                l14: '',
                l15: ''
            },
            statusCodes: {
				B_COMPLETE: false,
				C_COMPLETE: false,
				D_COMPLETE: false,
				E_COMPLETE: false
			},
            firearmsIncomplete: [],
            firearmSearchResults: [],
            assignedFirearms: [],
            serialNumberLookup: null,
            firearmMessage: null,
            firearmMessageIndex: null,
            showHelp: [],
            extraAddress: false,
            contact_data: {
                first_name: '',
                last_name: '',
                address_1: '',
                city: '',
                state: '',
                zip_code: ''
            },
            changeLog:[],
            form: {
                contact_id: '',
                form_number: '',
                nics_number: '',
                form_data: {
                    section_a: {
                        firearms_list: [
                            {
                                caliber: "",
                                ffl_log_book_entry_id: "",
                                gun_type: "",
                                manufacturer: "",
                                model: "",
                                serial_number: ""
                            }
                        ],
                        total_firearms_transferred: '',
                        transaction_pawn_redemption: '',
                        transaction_pawn_redemption_line_numbers: '',
                        private_party_transfer: ''
                    },
                    section_b: {
                        actual_buyer: '',
                        addict: '',
                        address_1: '',
                        birth_city: '',
                        birthdate: '',
                        citizen_country_code: '',
                        citizen_country_code_2: '',
                        citizen_country_code_3: '',
                        citizen_status_code: '',
                        origin_country: "",
                        city: '',
                        convict: '',
                        county: '',
                        customer_race: {l4: '', l2: '', l6: '', l1: '', l5: ''},
                        dishonorable_discharge: '',
                        domestic_violence: '',
                        ethnicity: '',
                        exc_code: '',
                        feet: '',
                        first_initial: '',
                        first_name: '',
                        foreign_country: '',
                        fugitive: '',
                        gender_code: '',
                        home_address_1: '',
                        home_city: '',
                        home_county: '',
                        home_state: '',
                        home_zip_code: '',
                        i_certify: '',
                        illegal_alien: '',
                        inches: '',
                        last_initial: '',
                        last_name: '',
                        legal_alien: '',
                        mental: '',
                        middle_initial: '',
                        middle_name: '',
                        mnu1: '',
                        no_middle_name: '',
                        pob_code: '',
                        renounced_citizenship: '',
                        restraining_order: '',
                        signature: '',
                        signed_date: '',
                        ssn: '',
                        state: '',
                        suffix: '',
                        under_indictment: '',
                        upin: '',
                        weight: '',
                        zip_code: ''
                    },
                    section_c: {
                        buyer_identification_expiration_date: '',
                        buyer_identification_issuing_authority_and_type: '',
                        buyer_identification_number: '',
                        buyer_identification_type_code: '',
                        buyer_identification_type_description: '',
                        buyer_supplemental_government_documentation: '',
                        customer_trans_purpose: {l1: '', l2: '', l3: ''},
                        employee_completing_nics: '',
                        exception_to_the_nonimmigrant_alien_prohibition_documentation: '',
                        gun_show_location: '',
                        gun_show_name: '',
                        nics_after_transfer_response: '',
                        nics_after_transfer_response_date: '',
                        nics_buyer_background_check: '',
                        nics_buyer_exempt: '',
                        nics_buyer_exempt_permit_date_expiration: '',
                        nics_buyer_exempt_permit_date_issuance: '',
                        nics_buyer_exempt_permit_number: '',
                        nics_buyer_exempt_permit_state_type: '',
                        nics_examiner_brady_number: '',
                        nics_examiner_name: '',
                        nics_firearm_may_be_transferred: '',
                        nics_initial_response: '',
                        nics_initial_response_date: '',
                        nics_later_response_cancelled: '',
                        nics_later_response_cancelled_date: '',
                        nics_later_response_denied: '',
                        nics_later_response_denied_date: '',
                        nics_later_response_no_response: '',
                        nics_later_response_overturned: '',
                        nics_later_response_proceed: '',
                        nics_later_response_proceed_date: '',
                        permanent_change_of_station_city_state: '',
                        permanent_change_of_station_effective_date: '',
                        permanent_change_of_station_order_number: '',
                    },
                    section_d: {
                        buyer_recertification_signature: '',
                        buyer_recertification_date: ''
                    },
                    section_e: {
                        seller_notes: '',
                        seller_name_address_ffl: '',
                        seller_name: '',
                        seller_signature: '',
                        transfer_date: '',
                        not_transferred: ''
                    }
                }
            },
            signaturePadOnScreen: false,
            scriptel: null,
            capturingSignature: false,
            savedSignature: null,
            signedDateError: null,
            signaturePad: null,
            cancellingForm: false,
            unsavedChangesWarning: false,
            savingFinalSectionWarning: false,
            missingSectionCWarning: false,
            forceSave: false,
            filesUploadModalOpen: false,
            filesAdded: 0,
            fileReference: [],
            confirmFileRemove: null,
            uploadMessage: null,
            canUseScreenCaptureSignature: false,
            enicsCertificateFilenamePresent: null,
            nicsEZCheck: false,
            nicsEZCheckInProgress: false,
            nicsEZCheckComplete: false,
            nicsEZCheckResearchingResponse: false,
            nicsEZCheckError: false,
            nicsEZCheckErrorMessage: null,
            nicsContactFirstName: null,
            nicsContactLastName: null,
            nicsContactPhoneNumber: null,
            nicsContactLeepUserId: null,
            sectionESignatureMessage: '',
            generatingPDF: false,
            generatingPDFMessage: ''
        }
    },
    created() {
		if (this.id && this.id != 'new') {
			this.fetchData()
		}
	},
    mounted() {
        // include scriptel library
		let scriptelScript = document.createElement('script')
        scriptelScript.setAttribute('id', 'scriptel_script')
		scriptelScript.setAttribute('src', '/dashboard/js/scriptel-easyscript.js')
		document.head.appendChild(scriptelScript)
        // listen for nics response
        window.addEventListener('nics_response_to_form', (e) => {
            this.form.form_data.section_c.nics_initial_response = e.detail.nics_initial_response
            this.form.nics_number = e.detail.nics_number
            this.form.form_data.section_c.nics_initial_response_date = this.$moment().format('YYYY-MM-DD')
        })
    },
    computed: {
        ...mapState({
            getEnicsTransactionPurposeIds: (state, getters) => getters['logbooks/getEnicsTransactionPurposeIds'],
            getEnicsCadenceCodes: (state, getters) => getters['logbooks/getEnicsCadenceCodes'],
            getEnicsStateOfResidenceCodes: (state, getters) => getters['logbooks/getEnicsStateOfResidenceCodes'],
        }),
        filesDropzoneOptions() {
            return {
    			url: this.getApiEndpoint + '?action=upload_form_attachments',
    			withCredentials: true,
    			uploadMultiple: false,
    			paramName: 'upload_file',
    			maxFilesize: 4,
                createImageThumbnails: false,
                acceptedFiles: 'image/*, application/pdf',
                previewsContainer: '.uploaded-files',
    			params: {
    				fd_token: this.$getCookie('dashboard_token'),
    				source: 'LOGBOOKS',
                    ffl_log_book_form_id: this.id
    			}
            }
        },
		canSaveSection() {
            // NOTE: we need to confirm that the only way to edit a section where section E has been saved is with Correct Section?
            if (this.forceSave) {
                return true
            }
            if (this.formSection == 'section_a' && !this.statusCodes.E_COMPLETE) { // || this.clientHasVariance
                return true
            }
            if (this.formSection == 'section_c' && (this.form.form_data.section_c.customer_trans_purpose.l1 || this.form.form_data.section_c.customer_trans_purpose.l2 || this.form.form_data.section_c.customer_trans_purpose.l3) && !this.statusCodes.E_COMPLETE) { // || this.clientHasVariance
                return true
            }
            if (this.formSection == 'section_e' && this.sectionComplete('E')) { //  && this.statusCodes.E_COMPLETE) || this.clientHasVariance
                return true
            }
            // if (['section_b', 'section_d'].includes(this.formSection) && this.clientHasVariance) {
            //     return true
            // }
            return false
        },
        canSignSectionE() {
            if (this.form.form_data.section_e.not_transferred) {
                console.log('Can sign: not transferred')
                return true
            }
            if (this.form.form_data.section_c.nics_buyer_background_check || this.form.form_data.section_c.nics_buyer_exempt) {
                console.log('Can sign: exempt')
                return true
            }
            if (!this.form.form_data.section_c.nics_initial_response_date || !this.form.nics_number || !this.form.form_data.section_c.nics_initial_response) {
                console.log('Cannot sign: missing 27.a, b, or c')
                return false
            }
            if (this.form.form_data.section_c.nics_initial_response == 'Delayed') {
                if (!this.form.form_data.section_c.nics_later_response_proceed && !this.form.form_data.section_c.nics_later_response_denied && !this.form.form_data.section_c.nics_later_response_cancelled && !this.form.form_data.section_c.nics_later_response_no_response && !this.form.form_data.section_c.nics_later_response_overturned) {
                    console.log('Cannot sign: delayed pending')
                    return false
                }
            }
            console.log('Can sign')
            return true
        },
        today() {
			return this.$moment().format('YYYY-MM-DD')
		},
        newForm() {
            return this.id == 'new' || this.correctingForm
        },
        readyForNICSCheck() {
			return (this.form.form_data.section_c.buyer_identification_issuing_authority_and_type && this.form.form_data.section_c.buyer_identification_type_code && this.form.form_data.section_c.buyer_identification_number)
		},
        customerTransPurposeSet() {
            //if (!this.nicsContactFirstName || !this.nicsContactLastName || !this.nicsContactPhoneNumber || !this.nicsContactLeepUserId) return false
			for (let prop in this.customerTransPurpose) {
				if (this.customerTransPurpose[prop]) return true
			}
			return false
		},
        customerTransPurposeList() {
			let customerTransPurposeList = []
			for (let prop in this.customerTransPurpose) {
				if (this.customerTransPurpose[prop]) {
					customerTransPurposeList.push(TRANSACTION_PURPOSES[prop])
				}
			}
			return customerTransPurposeList
		},
        customerRaceCodes() {
			let customerRaceCodes = []
			for (let race in this.form.form_data.customerRace) {
				if (this.form.form_data.customerRace[race]) {
					customerRaceCodes.push(CUSTOMER_RACE_CODES[race])
				}
			}
			return customerRaceCodes
		},
        sectionLetter() {
            switch (this.formSection) {
                case 'section_a':
                    return 'A'
                    break;
                case 'section_b':
                    return 'B'
                    break;
                case 'section_c':
                    return 'C'
                    break;
                case 'section_d':
                    return 'D'
                    break;
                case 'section_e':
                    return 'E'
                    break;
                default:
                    return 'A'
            }
        },
        enableCorrection() {
            if (!this.clientHasVariance || this.form.moved_to_ffl_log_book_form_id) {
                return false
            }
            if (this.correctingForm) {
                return false
            }
            if (this.formSection == 'section_a' && this.statusCodes.A_COMPLETE) {
                return true
            }
            if (this.formSection == 'section_b' && this.statusCodes.B_COMPLETE) {
                return true
            }
            if (this.formSection == 'section_c' && this.statusCodes.E_COMPLETE) {
                return true
            }
            if (this.formSection == 'section_d' && this.statusCodes.D_COMPLETE) {
                return true
            }
            if (this.formSection == 'section_e' && this.statusCodes.E_COMPLETE) {
                return true
            }
        },
        sectionBAlert() {
            return this.form.customer_disqualified
        },
		userCanEdit() {
            return this.getUser.manager_flag
		},
        // Not sure this is the best way to prune the ones we don't need as these might change in the future
        transactionPurposes() {
            let allowedIDs = [1, 2, 3, 5, 6, 7, 9, 10, 11, 27, 28, 29, 30, 31, 32]
            let transactionPurposes = {}
            // console.log(allowedIDs.includes(1));
            for (let id in this.getEnicsTransactionPurposeIds) {
                // console.log(id, allowedIDs.includes(parseInt(id)));
                if (this.getEnicsTransactionPurposeIds.hasOwnProperty(id) && allowedIDs.includes(parseInt(id))) {
                    transactionPurposes[id] = this.getEnicsTransactionPurposeIds[id]
                }
            }
            return transactionPurposes
        }
    },
    watch: {
        showSavingForm(value) {
            if (value) {
                setTimeout(() => {
                    this.showSavingForm = false
                    this.saveError = false
                }, 3000)
            }
        },
        id(newVal, oldVal) {
            if (newVal != oldVal) {
                this.fetchData()
            }
        },
		firearmMessage(newVal) {
			if (newVal) {
				setTimeout(() => {
					this.firearmMessageIndex = null
					this.firearmMessage = null
				}, 2000)
			}
		},
        'form.form_data.section_b.signed_date' (newVal) {
            this.form.form_data.section_b.signed_date = newVal
        },
        "form.form_data.section_c.nics_initial_response"(newVal) {
			if (newVal == 'Delayed' && !this.form.form_data.section_c.nics_firearm_may_be_transferred) {
				// delayed needs to add three weekdays to current date
				// https://gist.github.com/psdtohtml5/7000529
				var addDays = 3
				var today = new Date()
			    var d = new Date(today.getTime())
			    var day = d.getDay()
			    d.setDate(d.getDate() + addDays + (day === 6 ? 2 : +!day) + (Math.floor((addDays - 1 + (day % 6 || 1)) / 5) * 2))
				this.form.form_data.section_c.nics_firearm_may_be_transferred = this.$moment(d).format('YYYY-MM-DD');
			}
		},
        uploadMessage(value) {
            if (value) {
                setTimeout(() => {
                    this.uploadMessage = null
                }, 5000)
            }
        }
    },
    methods: {
        showSection(section) {
            if (section == this.formSection) {
                return
            }
            if (this.formSection == 'section_c' && JSON.stringify(this.formCopy.form_data.section_c) != JSON.stringify(this.form.form_data.section_c)) {
                this.unsavedChangesWarning = true
                return
            }
            this.formSection = section
        },
        sectionComplete(which) {
            var isComplete = false
            switch(which) {
                case 'A':
                    isComplete = this.form.form_data.section_a.total_firearms_transferred != '' && this.form.form_data.section_a.total_firearms_transferred != 'zero'
                    break;
                case 'B':
                    isComplete = this.form.form_data.section_b.actual_buyer
                    break;
                case 'C':
                    isComplete = (this.form.form_data.section_c.customer_trans_purpose.l1 || this.form.form_data.section_c.customer_trans_purpose.l2 || this.form.form_data.section_c.customer_trans_purpose.l3) &&
                    (this.form.form_data.section_c.nics_initial_response ||
                    this.form.form_data.section_c.nics_buyer_background_check ||
                    (this.form.form_data.section_c.nics_buyer_exempt && this.form.form_data.section_c.nics_buyer_exempt_permit_state_type))
                    break;
                case 'D':
                    isComplete = this.form.form_data.section_d.buyer_recertification_signature
                    break;
                case 'E':
                    if (this.statusCodes.E_COMPLETE) {
                        isComplete = true // accounts for older forms saved with just a "not transferred" check
                    } else {
                        isComplete = this.form.form_data.section_e.seller_name && this.form.form_data.section_e.seller_signature &&
                        (this.form.form_data.section_e.transfer_date || this.form.form_data.section_e.not_transferred)
                    }
                    break;
            }
            return isComplete
        },
        fetchData() {
            this.enicsCertificateFilenamePresent = this.getEnicsCertificateFilename
            this.apiCall({ destination: 'get_item_ffl_log_book_form', data: { ffl_log_book_form_id: this.id } }).then(obj => {
                this.form = obj.log_book_form
                this.contact_data = obj.contact_data
                setTimeout(() => {
                    if (obj.log_book_form.form_data.section_b.home_address_1) {
                        this.extraAddress = true
                    }
                    if (this.form.form_data.section_a.firearms_list.length == 0) {
                        this.form.form_data.section_a.firearms_list.push({ manufacturer: '', model: '', serial_number: '', gun_type: '', caliber: '' })
                    }

                    // // transition to storing country code for section b
                    // if (this.form.form_data.section_b.foreign_country && this.form.form_data.section_b.foreign_country.length > 2) {
                    //     let foreignCountryCode = Object.keys(this.COUNTRIES_LIST).find(key => this.COUNTRIES_LIST[key] === this.form.form_data.section_b.foreign_country)
                    //     this.form.form_data.section_b.foreign_country = foreignCountryCode
                    // }

                    if (obj.log_book_form.form_data.section_e.seller_name_address_ffl == '') {
                        this.form.form_data.section_e.seller_name_address_ffl = `${this.getClient.company_name}\n${this.getClient.address_1}\n`
                        this.form.form_data.section_e.seller_name_address_ffl += (this.getClient.address_2) ? this.getClient.address_2 + '\n' : ''
                        this.form.form_data.section_e.seller_name_address_ffl += `${this.getClient.city}, ${this.getClient.state} ${this.getClient.zip_code}\nFFL#: ${this.getClient.ffl_number}`
                    }
                    this.statusCodes = obj.log_book_form.status_codes
                    if (!this.statusCodes.B_COMPLETE && this.form.form_data.section_a.firearms_list[this.form.form_data.section_a.firearms_list.length - 1].serial_number != '') {
                        this.form.form_data.section_a.firearms_list.push({caliber: "",ffl_log_book_entry_id: "",gun_type: "",manufacturer: "",model: "",serial_number: ""})
                    }
                    if (!this.statusCodes.E_COMPLETE) {
                        this.form.form_data.section_e.transfer_date = this.$moment().format('YYYY-MM-DD')
                    }
                    this.movedFromFFLLogBookFormId = obj.moved_from_ffl_log_book_form_id
                    if (obj.change_log) {
                        this.changeLog = obj.change_log
                    }
                    this.formCopy = this.$copy(this.form)
                    this.clientHasVariance = obj.electronic_storage_variance
                    this.canUseScreenCaptureSignature = obj.enable_screen_capture_signature
                    this.getLogBookFormAttachments()
                    this.nicsContactPhoneNumber = this.getClient.phone_number

                    this.loading = false

                }, 500)

            })
        },
        getLogBookFormAttachments() {
            this.apiCall({ destination: 'get_log_book_form_attachments', data: { ffl_log_book_form_id: this.id } }).then(obj => {
                this.fileReference = obj.file_reference
            })
        },
        searchContacts() {
			if (!this.search_customers) return
			this.customers = null
			this.customerSearchMessage = null
			this.apiCall({ destination: 'get_list_contacts', data: { search_term: this.search_customers }}).then(obj => {
				if (obj.status == 'error') {
					this.customerSearchMessage = obj.message
				} else if (obj.list.customers.length > 0) {
					this.customers = obj.list.customers
				} else {
					this.customerSearchMessage = 'No matching customers found.'
				}
			})
		},
        assignCustomer(customer) {
			// ATF requires customer to manaully enter all info
			// so we'll simply assign the contact_id, and upon submit we'll update the contact in the database
			// but go ahead and populate if in dev environment
			// if (document.location.hostname.indexOf('.test') > -1) {
			// 	for (var key in customer) {
			// 	    if (!this.form.form_data.section_b.hasOwnProperty(key)) continue
			// 	    this.form.form_data.section_b[key] = customer[key]
			// 	}
			// }
			this.form.contact_id = customer.contact_id
            this.contact_data = customer
            this.newContact = {
                first_name: null,
                last_name: null
            }
            this.creatingContact = false
		},
        createContact() {
            this.newContactMessage = null
            if (!this.newContact.first_name || !this.newContact.last_name) {
                this.newContactMessage = 'First and last name are both required.'
                return
            }
            this.apiCall({ destination: 'save_item_contact', data: { ...this.newContact }}).then(obj => {
                if (obj.status == 'success') {
                    this.form.contact_id = obj.contact_id
                    this.contact_data.first_name = this.newContact.first_name
                    this.contact_data.middle_name = this.newContact.middle_name
                    this.contact_data.last_name = this.newContact.last_name
                    this.contact_data.suffix = this.newContact.suffix
                } else {
                    this.newContactMessage = obj.message
                }
            }).catch(err => {
                console.log(err);
            })
        },
        generatePDFLink() {
            let pdfLink = this.getPDFAPIEndpoint + '?action=form_4473_pdf&source=logbooks&fd_token=' + getCookie('dashboard_token') + '&form_id=' + this.$randomString(6) + this.id + this.$randomString(6) + this.form.client_id
            pdfLink += (this.$route.query.debug) ? "&debug=1" : ""
			return pdfLink
		},
        generatePDF() {
            this.generatingPDFMessage = this.contact_data.full_name || this.contact_data.first_name + ' ' + this.contact_data.middle_name + ' ' + this.contact_data.last_name + ' ' + this.contact_data.suffix
            this.generatingPDF = true
            // use dedicated pdf server
            let url = this.getPDFAPIEndpoint + '?action=form_4473_pdf'
            this.apiCall({ destination: url, data: { form_id: this.id, client_id: this.form.client_id, download: 1 }}).then(obj => {
                if (obj.status == 'success') {
                    // close the modal and download the pdf
					document.getElementById("download").src = obj.download_url
					this.generatingPDF = false
					this.generatingPDFMessage = ''
                } else {
                    this.generatingPDFMessage = obj.message
                }
            }).catch(err => {
                console.log(err);
            })
        },
        generateAttachmentLink(attachmentId) {
            //let pdfLink = this.getApiEndpoint + '?action=form_4473_attachment&source=logbooks&attachment_id=' + this.$randomString(6) + attachmentId + this.$randomString(6) + this.form.client_id + this.$randomString(6)
            let pdfLink = this.getApiEndpoint + '?action=form_4473_attachment&source=logbooks&fd_token=' + getCookie('dashboard_token') + '&attachment_id=' + this.$randomString(6) + attachmentId + this.$randomString(6)
            pdfLink += (this.$route.query.debug) ? "&debug=1" : ""
			return pdfLink
		},
        bookmarkForm() {
			this.apiCall({ destination: 'save_item_ffl_log_book_form_bookmark', data: { ffl_log_book_form_id: this.id, bookmark: !this.form.bookmarked } }).then((obj) => {
				if (obj.status == 'success') {
                    this.form.bookmarked = !this.form.bookmarked
				}
			}).catch((err) => {
				console.log(err)
			})
		},
        copyForm() {
            if (this.formSection == 'section_b') {
                this.sectionBCorrectionDialog = true
                return
            }
            if (this.formSection == 'section_d') {
                this.sectionDCorrectionDialog = true
                return
            }
            this.formCopy = this.$copy(this.form)
            this.correctingForm = true
            this.statusCodes = {
                A_COMPLETE: false,
                B_COMPLETE: false,
				C_COMPLETE: false,
				D_COMPLETE: false,
				E_COMPLETE: false
            }
        },
        revertForm() {
            this.form = this.$copy(this.formCopy)
            this.statusCodes = this.form.status_codes
            this.correctingForm = false
            this.formCorrectWarning = false
            this.userInitials = ''
        },
        validateFormCorrect() {
            if (!this.userInitials) { return }
            this.formCorrectErrors.length = 0
            // Clean up firearms list
            let lastFirearmIndex = this.form.form_data.section_a.firearms_list.length - 1
            if (this.firearmComplete(this.form.form_data.section_a.firearms_list[lastFirearmIndex]).length != 5) {
                this.form.form_data.section_a.firearms_list.splice(lastFirearmIndex, 1)
            }
            if (this.formSection == 'section_a' && this.form.form_data.section_a.firearms_list.length == 0) {
                this.form.form_data.section_a.firearms_list.push({ manufacturer: '', model: '', serial_number: '', gun_type: '', caliber: '' })
                this.formCorrectErrors.push('Firearms list may not be empty')
                this.formCorrectWarning = true
                return
            }
            // Validate Section E
            if (this.formSection == 'section_e') {
                if (!this.form.form_data.section_e.seller_name_address_ffl) this.formCorrectErrors.push('33. Seller name / address / ffl')
                if (!this.form.form_data.section_e.seller_name) this.formCorrectErrors.push('34. Seller name')
                this.formCorrectWarning = true
                return
            }
            // Cleanup fields we populate automatically but shouldn't be saved
            this.form.form_data.section_d.buyer_recertification_date = (!this.form.form_data.section_d.buyer_recertification_signature)
                ? null
                : this.form.form_data.section_d.buyer_recertification_date
            this.form.form_data.section_e.seller_name_address_ffl = (!this.form.form_data.section_e.seller_signature)
                ? null
                : this.form.form_data.section_e.seller_name_address_ffl
            this.form.form_data.section_e.transfer_date = (!this.form.form_data.section_e.seller_signature)
                ? null
                : this.form.form_data.section_e.transfer_date
            this.finishFormCorrect()
        },
        finishFormCorrect() {
            let data = {
                contact: {
                    contact_id: this.contact_data.contact_id,
                    client_id: this.contact_data.client_id,
                    first_name: this.contact_data.first_name,
                    middle_name: this.contact_data.middle_name,
                    last_name: this.contact_data.last_name,
                    suffix: this.contact_data.suffix,
                    address_1: this.contact_data.address_1,
                    city: this.contact_data.city,
                    state: this.contact_data.state,
                    zip_code: this.contact_data.zip_code,
                    birthdate: this.contact_data.birthdate
                },
                old_ffl_log_book_form_id: this.id,
                form: this.form,
                user_initials: this.userInitials
            }
            this.apiCall({ destination: 'move_item_4473', data: data }).then(obj => {
                if (obj.status == 'success') {
                    this.formCorrectWarning = false
                    this.userInitials = ''
                    this.correctingForm = false
                    // since we're correcting a v2 form, the route should be v2!
                    this.$router.push('/logbooks/4473-v2/' + obj.ffl_log_book_form_id)
                }
            }).catch(err => {
                console.log(err);
            })
        },
        saveFormNumber() {
			this.apiCall({ destination: 'save_4473_form_number', data: { ffl_log_book_form_id: this.id, form_number: this.form.form_number } }).then(obj => {
				if (obj.status == 'success') {
					this.formNumberMessage = 'Form number saved!'
				} else {
					this.formNumberMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
        forceSaveForm() {
            // certain data can still be saved even if entire form is locked
            this.forceSave = true
            this.saveForm()
        },
        saveNotes() {
            if (this.form.form_data.section_e.seller_notes) {
                this.savingForm = true
                this.apiCall({ destination: 'save_4473_notes', data: { ffl_log_book_form_id: this.id, notes: this.form.form_data.section_e.seller_notes } }).then(obj => {
                    this.savingForm = false
                    this.formSaveMessage = obj.message
                })
            }
        },
        saveForm() {
            if (!this.canSaveSection) {
                return
            }
            // this.form.form_data.section_b.signed_date = (this.form.form_data.section_b.signature == '')
            //     ? ''
            //     : this.form.form_data.section_b.signed_date
            // this.form.form_data.section_d.buyer_recertification_date = (this.form.form_data.section_d.buyer_recertification_signature == '')
            //     ? ''
            //     : this.form.form_data.section_d.buyer_recertification_date
            //this.form.form_data.section_e.transfer_date = (this.form.form_data.section_e.seller_signature == '')
            //    ? ''
            //    : this.form.form_data.section_e.transfer_date
            //this.form.form_data.file_reference = this.file_reference

            let data = {
                ffl_log_book_form_id: this.id,
                form: this.form,
                form_section: this.formSection,
                force_save: this.forceSave
            }

            switch (this.formSection) {
                case 'section_a':
                    // trim empty rows in firearms_list
                    for (let i = 0; i < this.form.form_data.section_a.firearms_list.length; i++) {
                        if (this.firearmComplete(this.form.form_data.section_a.firearms_list[i]).length < 5) {
                            this.form.form_data.section_a.firearms_list.splice(i, 1)
                        }
                    }
                    if (this.form.form_data.section_a.firearms_list.length == 0) {
				        this.form.form_data.section_a.firearms_list.push({ manufacturer: '', model: '', serial_number: '', gun_type: '', caliber: '' })
                        this.showSavingForm = true
                        this.saveError = true
                        this.formSaveMessage = '<span class="error">Section A is incomplete!</span>'
                        return
                    }
                    this.showSavingForm = true
                    this.savingForm = true
                    if (this.newForm) {
                        this.apiCall({ destination: 'save_4473', data: data }).then(obj => {
                            this.savingForm = false
                            if (this.newForm && obj.status == 'success') {
                                this.$router.push('/logbooks/4473/' + obj.ffl_log_book_form_id)
                            } else if (obj.status == 'success') {
                                this.formSaveMessage = 'Form successfully saved'
                            } else {
                                this.formSaveMessage = obj.message
                            }
                        })
                        return;
                    }
                    break;
                case 'section_b':
                    if (!this.validateSectionB()) {
                        this.formSaveMessage = '<span class="error">Section B is incomplete!</span>'
                        return
                    }
                    data.contact = {
        				contact_id: this.form.form_data.section_b.contact_id,
        				client_id: this.form.form_data.section_b.client_id,
        				first_name: this.form.form_data.section_b.first_name,
        				middle_name: this.form.form_data.section_b.middle_name,
        				last_name: this.form.form_data.section_b.last_name,
        				suffix: this.form.form_data.section_b.suffix,
        				address_1: this.form.form_data.section_b.address_1,
        				city: this.form.form_data.section_b.city,
        				state: this.form.form_data.section_b.state,
        				zip_code: this.form.form_data.section_b.zip_code,
        				birthdate: this.form.form_data.section_b.birthdate
        			}
                    data.form_section = this.formSection
                    break;
                case 'section_d':
                    if (!this.form.form_data.section_d.buyer_recertification_date || !this.form.form_data.section_d.buyer_recertification_signature) {
                        this.formSaveMessage = '<span class="error">Section D is incomplete!</span>'
                        return
                    }
                case 'section_e':
                    if (this.forceSave) {
                        // we're just saving the notes, so if no signature, keep the date empty
                        if (!this.form.form_data.section_e.seller_signature) {
                            data.form.form_data.section_e.transfer_date = ''
                        }
                    } else {
                        if (!this.sectionComplete('C') && !this.form.form_data.section_e.not_transferred) {
                            this.missingSectionCWarning = true
                            return
                        }
                        if (!this.form.form_data.section_e.not_transferred &&
                        (!this.form.form_data.section_e.seller_name_address_ffl ||
                            !this.form.form_data.section_e.seller_name ||
                            !this.form.form_data.section_e.seller_signature ||
                            !this.form.form_data.section_e.transfer_date)) {
                                this.formSaveMessage = '<span class="error">Section E is incomplete!</span>'
                                return
                            }
                        if (!this.savingFinalSectionWarning) {
                            this.savingFinalSectionWarning = true
                            return;
                        }
                    }
                    break;
            }
            this.showSavingForm = true
            this.savingForm = true
            this.apiCall({ destination: 'save_4473_section', data: data }).then(obj => {
                this.savingForm = false
                if (obj.status == 'success') {
                    this.formSaveMessage = 'Form successfully saved'
                    this.statusCodes = obj.log_book_form.status_codes
                    this.checkFirearmsList(this.form.form_data.section_a.firearms_list.length - 1)
                    // recopy the now saved form
                    this.formCopy = this.$copy(this.form)
                    this.savingFinalSectionWarning = false
                    this.forceSave = false
                } else {
                    this.formSaveMessage = obj.message
                }
            })
        },
        saveFormAttachments() {
            let data = {
                ffl_log_book_form_id: this.id,
                file_reference: this.fileReference
            }
            this.apiCall({ destination: 'save_log_book_form_attachments', data: data }).then(obj => {
                if (obj.status != 'success') {
                    this.uploadMessage = obj.message
                } else {
                    this.getLogBookFormAttachments()
                    this.uploadMessage = 'All files saved!'
                }
            })
        },
        cancelSaveFinalSection() {
            this.form.form_data.section_e.seller_notes = ''
            this.form.form_data.section_e.seller_name = ''
            this.form.form_data.section_e.seller_signature = ''
            this.form.form_data.section_e.transfer_date = this.$moment().format('YYYY-MM-DD')
            this.form.form_data.section_e.not_transferred = ''
            this.savingFinalSectionWarning = false
        },
        validateSectionB() {
			// explicit checks allow us to keep validation in order of display fields
			if (!this.form.form_data.section_b.first_name) {
				this.scroll('first_name')
				return false
			} else {
				this.removeError('first_name')
			}
			if (!this.form.form_data.section_b.middle_name && !this.form.form_data.section_b.no_middle_name) {
				this.scroll('middle_name')
				return false
			} else {
				this.removeError('middle_name')
			}
			if (!this.form.form_data.section_b.last_name) {
				this.scroll('last_name')
				return false
			} else {
				this.removeError('last_name')
			}
			if (!this.form.form_data.section_b.address_1) {
				this.scroll('address_1')
				return false
			} else {
				this.removeError('address_1')
			}
			if (!this.form.form_data.section_b.city) {
				this.scroll('city')
				return false
			} else {
				this.removeError('city')
			}
			if (!this.form.form_data.section_b.county) {
				this.scroll('county')
				return false
			} else {
				this.removeError('county')
			}
			if (!this.form.form_data.section_b.state) {
				this.scroll('state')
				return false
			} else {
				this.removeError('state')
			}
			if (!this.form.form_data.section_b.zip_code) {
				this.scroll('zip_code')
				return false
			} else {
				this.removeError('zip_code')
			}
			if (!this.form.form_data.section_b.birth_city && !this.form.form_data.section_b.foreign_country) {
				this.scroll('place_of_birth')
				return false
			} else {
				this.removeError('place_of_birth')
			}
			if (!this.form.form_data.section_b.pob_code && !this.form.form_data.section_b.foreign_country) {
				this.scroll('place_of_birth_state')
				return false
			} else {
				this.removeError('place_of_birth_state')
			}
			if (!this.form.form_data.section_b.feet) {
				this.scroll('feet')
				return false
			} else {
				this.removeError('feet')
			}
			if (!this.form.form_data.section_b.inches) {
				this.scroll('inches')
				return false
			} else {
				this.removeError('inches')
			}
			if (!this.form.form_data.section_b.weight) {
				this.scroll('weight')
				return false
			} else {
				this.removeError('weight')
			}
			if (!this.form.form_data.section_b.gender_code) {
				this.scroll('sex')
				return false
			} else {
				this.removeError('sex')
			}
			if (!this.form.form_data.section_b.birthdate) {
				this.scroll('birthdate')
				return false
			} else {
				this.removeError('birthdate')
			}
			if (!this.form.form_data.section_b.ethnicity) {
				this.scroll('ethnicity')
				return false
			} else {
				this.removeError('ethnicity')
			}
			let raceIsComplete = []
			for (var key in this.form.form_data.section_b.customer_race) {
				if (!this.form.form_data.section_b.customer_race.hasOwnProperty(key)) continue
				if (this.form.form_data.section_b.customer_race[key]) raceIsComplete.push(key)
			}
			if (raceIsComplete.length == 0) {
				this.scroll('race')
				return false
			} else {
				this.removeError('race')
			}
			if (!this.form.form_data.section_b.actual_buyer) {
				this.scroll('actual_buyer')
				return false
			} else {
				this.removeError('actual_buyer')
			}
			if (!this.form.form_data.section_b.under_indictment) {
				this.scroll('under_indictment')
				return false
			} else {
				this.removeError('under_indictment')
			}
			if (!this.form.form_data.section_b.convict) {
				this.scroll('convict')
				return false
			} else {
				this.removeError('convict')
			}
			if (!this.form.form_data.section_b.fugitive) {
				this.scroll('fugitive')
				return false
			} else {
				this.removeError('fugitive')
			}
			if (!this.form.form_data.section_b.addict) {
				this.scroll('addict')
				return false
			} else {
				this.removeError('addict')
			}
			if (!this.form.form_data.section_b.mental) {
				this.scroll('mental')
				return false
			} else {
				this.removeError('mental')
			}
			if (!this.form.form_data.section_b.dishonorable_discharge) {
				this.scroll('dishonorable_discharge')
				return false
			} else {
				this.removeError('dishonorable_discharge')
			}
			if (!this.form.form_data.section_b.restraining_order) {
				this.scroll('restraining_order')
				return false
			} else {
				this.removeError('restraining_order')
			}
			if (!this.form.form_data.section_b.domestic_violence) {
				this.scroll('domestic_violence')
				return false
			} else {
				this.removeError('domestic_violence')
			}
			// 12.a.
			if (!this.form.form_data.section_b.citizen_status_code) {
				this.scroll('origin_country')
				return false
			} else {
				this.removeError('origin_country')
			}
			// 12a other option
			if (this.form.form_data.section_b.citizen_status_code == 'F' && !this.form.form_data.section_b.citizen_country_code) {
				this.scroll('origin_country')
				return false
			} else {
				this.removeError('origin_country')
			}
			if (this.form.form_data.section_b.citizen_status_code == 'C') {
				this.form.form_data.section_b.citizen_country_code = null
				this.form.form_data.section_b.citizen_country_code_2 = null
				this.form.form_data.section_b.citizen_country_code_3 = null
                this.form.form_data.section_b.exc_code = null
			} else {
				this.form.form_data.section_b.origin_country = this.COUNTRIES_LIST[this.form.form_data.section_b.citizen_country_code]
				this.form.form_data.section_b.origin_country += (this.form.form_data.section_b.citizen_country_code_2) ? ", " + this.COUNTRIES_LIST[this.form.form_data.section_b.citizen_country_code_2] : ""
				this.form.form_data.section_b.origin_country += (this.form.form_data.section_b.citizen_country_code_3) ? ", " + this.COUNTRIES_LIST[this.form.form_data.section_b.citizen_country_code_3] : ""
			}
			if (!this.form.form_data.section_b.renounced_citizenship) {
				this.scroll('renounced_citizenship')
				return false
			} else {
				this.removeError('renounced_citizenship')
			}
			if (!this.form.form_data.section_b.illegal_alien) {
				this.scroll('illegal_alien')
				return false
			} else {
				this.removeError('illegal_alien')
			}
			if (!this.form.form_data.section_b.legal_alien) {
				this.scroll('legal_alien')
				return false
			} else {
				this.removeError('legal_alien')
			}
			if (this.form.form_data.section_b.legal_alien == 'Yes' && !this.form.form_data.section_b.exc_code) {
				this.scroll('exc_code')
				return false
			} else {
				this.removeError('exc_code')
			}
			// 13
			if (this.form.form_data.section_b.citizen_status_code == 'F' && !this.form.form_data.section_b.mnu1) {
				this.scroll('mnu1')
				return false
			} else {
				this.removeError('mnu1')
			}
			if (!this.form.form_data.section_b.i_certify) {
				this.scroll('i_certify')
				return false
			} else {
				this.removeError('i_certify')
			}
			if (document.location.hostname.indexOf('.test') > -1) {
				console.log('dev environment, signature not required')
			} else {
				if (!this.form.form_data.section_b.signature) {
					this.scroll('signature')
					return false
				} else {
					this.removeError('signature')
				}
			}
			if (!this.form.form_data.section_b.signed_date) {
				this.scroll('signed_date')
				return false
			} else {
				this.removeError('signed_date')
			}

			// All good, so clean up data and return true!
			if (this.form.form_data.section_b.foreign_country && !this.form.form_data.section_b.birth_city) {
				this.form.form_data.section_b.pob_code = this.form.form_data.section_b.foreign_country
			}
			if (this.form.form_data.section_b.feet && !this.form.form_data.section_b.inches) {
				this.form.form_data.section_b.inches = ""
			}
			return true
		},
        scroll(id) {
			var el = this.$el.querySelector('#' + id)
			var rect = el.getBoundingClientRect()
		    var scrollTop = window.pageYOffset || document.documentElement.scrollTop
		    var top = rect.top + scrollTop - 100 // 100 is just a buffer to give a bit of padding on top
		    // TODO: window.scroll needs polyfill for edge and IE
		    window.scroll({ top: top, left: 0, behavior: "smooth"})
		    el.classList.add('error')
		},
        removeError(id) {
			var el = this.$el.querySelector('#' + id)
			if (el.classList.contains('error')) {
				el.classList.remove('error')
			}
		},
        serialSearch(index, serialNumber) {
			if (!serialNumber) return
			this.serialNumberLookup = index
			let excludeFromSearch = []
			for (var i = 0; i < this.form.form_data.section_a.firearms_list.length; i++) {
				if (this.form.form_data.section_a.firearms_list[i].serial_number != serialNumber) {
					excludeFromSearch.push(this.form.form_data.section_a.firearms_list[i].serial_number)
				}
			}
			this.apiCall({ destination: 'serial_number_lookup', data: { on_hand: 1, search_term: serialNumber, exclude: excludeFromSearch }}).then(obj => {
				if (obj.status == 'error') {
					this.firearmMessage = 'Serial number not found, please try again.'
					this.firearmMessageIndex = index
					this.serialNumberLookup = null
				} else if (obj.firearms_list.length > 1) {
					// display list to select from
					this.firearmSearchResults = obj.firearms_list
				} else if (obj.firearms_list.length == 1) {
					this.assignFirearmsList(index,obj.firearms_list[0])
					// this.checkFirearmsList(index)
					this.serialNumberLookup = null
				} else {
					this.firearmMessage = 'Serial number not found, please try again.'
					this.firearmMessageIndex = index
					this.serialNumberLookup = null
				}
			}).catch(err => {
				console.log(err)
				this.serialNumberLookup = null
			})
		},
        cancelSerialNumberSearchResults() {
			this.serialNumberLookup = null
			this.firearmSearchResults = []
			this.firearmMessage = ''
			this.form.form_data.section_a.firearms_list[this.form.form_data.section_a.firearms_list.length - 1]['serial_number'] = ''
		},
		assignFirearmsList(index,assignObject) {
			this.serialNumberLookup = null
			this.form.form_data.section_a.firearms_list[index].ffl_log_book_entry_id = assignObject.ffl_log_book_entry_id
			this.form.form_data.section_a.firearms_list[index].manufacturer = assignObject.manufacturer
			this.form.form_data.section_a.firearms_list[index].model = assignObject.model
			this.form.form_data.section_a.firearms_list[index].serial_number = assignObject.serial_number
			this.form.form_data.section_a.firearms_list[index].gun_type = assignObject.gun_type
			this.form.form_data.section_a.firearms_list[index].caliber = assignObject.caliber

			// we'll use this to compare if user changes any value in a firearm row
			this.assignedFirearms[index] = assignObject

			this.firearmSearchResults = []
			this.firearmMessage = ''
			this.checkFirearmsList(index)
		},
        checkFirearmsList(index) {
			var count = 0
			var complete = []
			this.form.form_data.section_a.firearms_list.forEach((firearm, index) => {
				// if we're not already editing a row, has user changed anything?
				if (this.firearmEditingIndex == null && this.assignedFirearms[index]) {
					for (let prop in firearm) {
						if (firearm[prop] != this.assignedFirearms[index][prop]) {
							this.firearmEditWarning = index
							return false
						}
					}
				}
				complete = this.firearmComplete(firearm)
				if (complete.length == 5) {
					count++
					var pos = this.firearmsIncomplete.findIndex((element) => {
						return element == index
					})
					if (pos > -1) {
						this.firearmsIncomplete.splice(pos, 1)
					}
				} else {
					if ((index < this.form.form_data.section_a.firearms_list.length - 1) && !this.firearmsIncomplete.includes(index)) {
						this.firearmsIncomplete.push(index)
					}
				}
			})
            // if row is complete, and we're on the last row, add a new row
			if (complete.length == 5 && (this.form.form_data.section_a.firearms_list.length - 1) == index) {
				this.form.form_data.section_a.firearms_list.push({ manufacturer: '', model: '', serial_number: '', gun_type: '', caliber: '' })
            }
            // how many completed rows?
			var count = 0
            for (var i = 0; i < this.form.form_data.section_a.firearms_list.length; i++) {
                if (this.firearmComplete(this.form.form_data.section_a.firearms_list[i]).length == 5) {
                    count++
                }
            }
		    this.form.form_data.section_a.total_firearms_transferred = this.$toWords(count)
		},
		firearmComplete(firearm) {
			var complete = []
			for (let prop in firearm) {
				// ignore ffl_log_book_entry_id, track which inputs have values
				if (prop != 'ffl_log_book_entry_id' && firearm[prop]) {
					complete.push(prop)
				}
			}
			return complete
		},
        isBlank(firearm) {
            return this.firearmComplete(firearm).length < 5
        },
        removeFirearm(index) {
            this.form.form_data.section_a.firearms_list.splice(index, 1)
            this.checkFirearmsList(this.form.form_data.section_a.firearms_list.length - 1)
        },
        toggleHelp(index) {
			if (this.showHelp.indexOf(index) > -1) {
				this.showHelp.splice(this.showHelp.indexOf(index), 1)
			} else {
				this.showHelp.push(index)
			}
		},
        forceNICSPhonCheck() {
			this.forcingNICSPhoneCheck = true
			this.nicsPhoneCheck = true
        },
        handleNicsPhoneCheck() {
			this.nicsPhoneCheck = false
		},
		openNicsFrame() {
			// this.continueCheck = true
			//this.cjisIframeUrl = "https://www.cjis.gov/"
			window.open("https://www.cjis.gov/")
		},
		handleFillNicsForm() {

            // No dashes allowed
            this.form.form_data.section_b.ssn = this.form.form_data.section_b.ssn.replace(/-/gi, '')
            this.form.form_data.section_b.mnu1 = this.form.form_data.section_b.mnu1.replace(/-/gi, '')
			this.form.form_data.section_c.buyer_identification_number = this.form.form_data.section_c.buyer_identification_number.replace(/-/gi, '')

            //let foreignCountryCode = this.form.form_data.section_b.foreign_country
            // FBI likes country abbreviations, so derive from country name
            let foreignCountryCode = ''
            if (this.form.form_data.section_b.foreign_country) {
                foreignCountryCode = Object.keys(this.COUNTRIES_LIST).find(key => this.COUNTRIES_LIST[key] === this.form.form_data.section_b.foreign_country)
                // if (!foreignCountryCode) {
                //     // newer forms are storing country abbreviation, not full country name!
                //     foreignCountryCode = this.form.form_data.section_b.foreign_country
                // }
            }

            let formInfo = {
                cds_first_name: this.form.form_data.section_b.first_name,
                cds_last_name: this.form.form_data.section_b.last_name,
                cds_middle_name: (this.form.form_data.section_b.no_middle_name) ? 'NMN' : this.form.form_data.section_b.middle_name,
                cds_initial_only: !this.form.form_data.section_b.no_middle_name && this.form.form_data.section_b.middle_initial,
                cds_no_middle_name: this.form.form_data.section_b.no_middle_name,
                cds_cadence_code: this.form.form_data.section_b.suffix,
                cds_address_1: this.form.form_data.section_b.address_1,
                cds_city: this.form.form_data.section_b.city,
                cds_state_code: this.form.form_data.section_b.state,
                cds_zip_code: this.form.form_data.section_b.zip_code,
                cds_county: this.form.form_data.section_b.county,
                cds_pob_code: (this.form.form_data.section_b.pob_code != '') ? this.form.form_data.section_b.pob_code : foreignCountryCode,
                cds_height: this.form.form_data.section_b.feet.toString() + this.form.form_data.section_b.inches.toString().padStart(2, "0"),
                cds_weight: this.form.form_data.section_b.weight,
                cds_gender_code: this.form.form_data.section_b.gender_code,
                cds_dob: this.$moment(this.form.form_data.section_b.birthdate).format('YYYYMMDD'),
                cds_ssn: this.form.form_data.section_b.ssn,
                cds_upin_amd_id: this.form.form_data.section_b.upin,
                cds_is_hispanic_or_latino: this.form.form_data.section_b.ethnicity == 'hispanic',
                cds_customer_race_l1: this.form.form_data.section_b.customer_race['l1'],
                cds_customer_race_l2: this.form.form_data.section_b.customer_race['l2'],
                cds_customer_race_l4: this.form.form_data.section_b.customer_race['l4'],
                cds_customer_race_l5: this.form.form_data.section_b.customer_race['l5'],
                cds_customer_race_l6: this.form.form_data.section_b.customer_race['l6'],
                cds_citizen_status_code: this.form.form_data.section_b.citizen_status_code,
                cds_citizen_country_code: this.form.form_data.section_b.citizen_country_code,
                cds_citizen_country_code_2: (this.form.form_data.section_b.citizen_country_code_2) ? this.form.form_data.section_b.citizen_country_code_2 : '',
                cds_citizen_country_code_3: (this.form.form_data.section_b.citizen_country_code_3) ? this.form.form_data.section_b.citizen_country_code_3 : '',
                cds_exc_code: (this.form.form_data.section_b.exc_code) ? ((this.form.form_data.section_b.exc_code == 'yes') ? 'Y' : 'N') : '',
                cds_customer_trans_purpose_l1: this.customerTransPurpose['l1'],
                cds_customer_trans_purpose_l2: this.customerTransPurpose['l2'],
                cds_customer_trans_purpose_l3: this.customerTransPurpose['l3'],
                cds_customer_trans_purpose_l4: this.customerTransPurpose['l4'],
                cds_customer_trans_purpose_l5: this.customerTransPurpose['l5'],
                cds_customer_trans_purpose_l6: this.customerTransPurpose['l6'],
                cds_customer_trans_purpose_l7: this.customerTransPurpose['l7'],
                cds_customer_trans_purpose_l8: this.customerTransPurpose['l8'],
                cds_customer_trans_purpose_l9: this.customerTransPurpose['l9'],
                cds_customer_trans_purpose_l10: this.customerTransPurpose['l10'],
                cds_customer_trans_purpose_l11: this.customerTransPurpose['l11'],
                cds_customer_trans_purpose_l12: this.customerTransPurpose['l12'],
                cds_customer_trans_purpose_l13: this.customerTransPurpose['l13'],
                cds_customer_trans_purpose_l14: this.customerTransPurpose['l14'],
                cds_customer_trans_purpose_l15: this.customerTransPurpose['l15']
            }

            // For middle_name there are checkboxes for IO and NMN
            // not so for first/last names so we just tack those on to the end if needed
            formInfo.LAST_NAME += (this.form.form_data.section_b.last_initial) ? " IO" : ""
			formInfo.FIRST_NAME += (this.form.form_data.section_b.first_initial) ? " IO" : ""

            formInfo.cds_mnu = {}
			if (this.form.form_data.section_c.buyer_identification_number) {
				formInfo.cds_mnu[this.form.form_data.section_c.buyer_identification_type_code] = this.form.form_data.section_c.buyer_identification_number
			}
            if (this.form.form_data.section_b.mnu1) {
                // Deprecated in favor of the dropdown for this.form.form_data.section_b.mnu_type_code1
                // If the MNU begins with an 'A', the type is AR, otherwise I9
                // let mnuTypeCode =
                //     (this.form.form_data.section_b.mnu1.charAt(0) == 'A')
                //         ? 'AR'
                //         : 'I9'

                // We'll need to strip any 'A' off the front off the AR#. LEEP only allows numeric numbers now.
				formInfo.cds_mnu[this.form.form_data.section_b.mnu_type_code1] = this.form.form_data.section_b.mnu1.charAt(0) == 'A' ? this.form.form_data.section_b.mnu1.substring(1) : this.form.form_data.section_b.mnu1
			}
			window.formInfo = formInfo
			var event = new CustomEvent('nics_data', { detail: formInfo });
			window.dispatchEvent(event);
			this.fillNicsFormChecked = true;
            window.addEventListener('nics_data_saved', () => {
                this.openNicsFrame()
                this.nicsOnlineCheck = false
            })
		},
        doNicsEZCheck() {
            this.nicsEZCheckInProgress = true
            // Contact is for the dealer's contact person.
            // Note to Bill: will need to create a preference for UserId.
            // Contact could also be saved with the 4473 form_data?
            let data = {
                passthrough: true,
                contact: {
                    ContactPersonGivenName: this.nicsContactFirstName,
                    ContactPersonSurName: this.nicsContactLastName,
                    ContactUserId: this.nicsContactLeepUserId,
                    ContactTelephoneNumberFullID: this.nicsContactPhoneNumber,
                },
                values: {
                    ffl_log_book_form_id: this.id,
                    person_index: 0,
                    demo: true,
                    PersonGivenName: this.form.form_data.section_b.first_name,
                    PersonMiddleName: (this.form.form_data.section_b.no_middle_name) ? "NMN" : this.form.form_data.section_b.middle_name,
                    PersonSurName: this.form.form_data.section_b.last_name,
                    DateOfBirth: {
                        Date: this.$moment(this.form.form_data.section_b.birthdate).format('YYYY-MM-DD')
                    },
                    Citizenship: (this.form.form_data.section_b.citizen_status_code == 'C') ? 'CITIZEN' : 'FOREIGN',
                    PlaceOfBirthCode: (this.form.form_data.section_b.pob_code != '') ? this.form.form_data.section_b.pob_code : this.form.form_data.section_b.foreign_country,
                    StateOfResidenceCode: this.form.form_data.section_b.state,
                    StateOfPurchaseCode: this.getClient.state,
                    Gender: this.form.form_data.section_b.gender_code,
                    SSNumber: { IdentificationID: this.form.form_data.section_b.ssn },
                    UPIN: this.form.form_data.section_b.upin,
                    PersonRaceCode: this.form.form_data.section_b.customer_race,
                    Hispanic: this.form.form_data.section_b.ethnicity == 'hispanic',
                    PurposeIDCode: this.customerTransPurpose
                }
            }
            if (this.form.form_data.section_b.first_intial) {
                data.values.PersonGivenName += '"IO"'
            }
            if (this.form.form_data.section_b.no_middle_name == '' && this.form.form_data.section_b.middle_initial) {
                data.values.PersonMiddleName += '"IO"'
            }
            if (this.form.form_data.section_b.last_intial) {
                data.values.PersonSurName += '"IO"'
            }
            if (this.form.form_data.section_b.citizen_country_code) {
				data.values.CountryOfCitizenshipCode = this.form.form_data.section_b.citizen_country_code
            }
            if (this.form.form_data.section_b.citizen_country_code_2) {
				data.values.CountryOfCitizenshipCode2 = this.form.form_data.section_b.citizen_country_code_2
            }
            if (this.form.form_data.section_b.citizen_country_code_3) {
				data.values.CountryOfCitizenshipCode3 = this.form.form_data.section_b.citizen_country_code_3
            }
            if (this.form.form_data.section_b.mnu1) {
                data.values.MnuPrefix = {
                    MNUCode: this.form.form_data.section_b.mnu_type_code1
                }
				data.values.MnuNumber = this.form.form_data.section_b.mnu1
                data.values.AdditionalMnuPrefix = {
                    AdditionalMNUCode: this.form.form_data.section_c.buyer_identification_type_code
                }
				data.values.AdditionalMnuNumber = this.form.form_data.section_c.buyer_identification_number
            } else {
                data.values.MnuPrefix = {
                    MNUCode: this.form.form_data.section_c.buyer_identification_type_code
                }
				data.values.MnuNumber = this.form.form_data.section_c.buyer_identification_number
            }
            if (this.form.form_data.section_b.citizen_status_code == 'F') {
                data.values.NonImmigrantExceptionCode = (this.form.form_data.section_b.exc_code) ? this.form.form_data.section_b.exc_code : 'X'
            }
            this.apiCall({ destination: 'nics_search_request', data: data }).then(obj => {
                this.nicsEZCheckInProgress = false
                this.nicsEZCheckComplete = true
                if (obj.status == "success" && obj.nics_search.status != 'NICS_RESEARCHING') {
                    this.form.nics_number = obj.nics_search.nics_number
                    this.form.form_data.section_c.nics_initial_response = obj.nics_search.nics_initial_response
                    this.form.form_data.section_c.nics_initial_response_date = obj.nics_search.nics_initial_response_date
                    this.form.form_data.section_c.nics_firearm_may_be_transferred = obj.nics_search.brady_transfer_date
                    this.form.status = obj.nics_search.status
                } else if (obj.status == "success" && obj.nics_search.status == 'NICS_RESEARCHING') {
                    this.form.nics_number = obj.nics_search.nics_number
                    this.form.form_data.section_c.nics_firearm_may_be_transferred = obj.nics_search.brady_transfer_date
                    this.form.status = obj.nics_search.status
                    this.nicsEZCheckResearchingResponse = true
                } else if (obj.status == "error") {
                    this.nicsEZCheckError = true
                    this.nicsEZCheckErrorMessage = obj.message
                }
            }).catch(err => {
                this.nicsEZCheckInProgress = false
                this.nicsEZCheckComplete = true
                this.nicsEZCheckError = true
                console.log(err);
            })
        },
        saveOnlineNTNStatus() {
			this.form.nics_number = nics_number.value
			this.form.form_data.section_c.nics_initial_response = nics_initial_response.value
			this.form.form_data.section_c.nics_initial_response_date = this.$moment().format('YYYY-MM-DD')
			this.nicsOnlineCheck = false
			this.scrollToNTN()
		},
        scrollToNTN() {
			var interval = setInterval(() => {
				if (this.$refs.form_nics_number) {
					clearInterval(interval)
					var rect = this.$refs.form_nics_number.getBoundingClientRect()
					var scrollTop = window.pageYOffset || document.documentElement.scrollTop
				    var top = rect.top + scrollTop - 100 // 100 is just a buffer to give a bit of padding on top
				    window.scroll({ top: top, left: 0, behavior: "smooth"})
				}
			}, 10)
		},
        captureBuyersSignature() {
            this.capturingSignature = true
            this.savedSignature = this.form.form_data.signature
        	this.form.form_data.signature = null
        	setTimeout(() => {
        		this.initializeSignaturePad('buyers_signature_pad')
        	}, 500)
        },
        restoreBuyersSignature() {
            this.capturingSignature = false
            this.form.form_data.signature = this.savedSignature
        },
        captureBuyersRecertificationSignature() {
            this.capturingSignature = true
            this.savedSignature = this.form.form_data.section_d.buyer_recertification_signature
        	this.form.form_data.section_d.buyer_recertification_signature = null
        	setTimeout(() => {
        		this.initializeSignaturePad('buyers_recertification_signature_pad')
        	}, 500)
        },
        restoreBuyersRecertificationSignature() {
            this.capturingSignature = false
            this.form.form_data.section_d.buyer_recertification_signature = this.savedSignature
        },
        captureSellerSignature(onScreen = false) {

            // canSignSectionE contains multiple criteria for allowing signature
            if (!this.canSignSectionE) { return }

            this.capturingSignature = true

            // global check of some edge cases before allowing employee to sign
            let validateMessage = ''

            // Category of firearm(s) to be transferred cannot be empty
            if (!this.form.form_data.section_c.customer_trans_purpose.l1 && !this.form.form_data.section_c.customer_trans_purpose.l2 && !this.form.form_data.section_c.customer_trans_purpose.l3) {
                validateMessage = 'Section C 24. must be completed'
            }

            // Customer identification cannot be empty
            if (!this.form.form_data.section_c.buyer_identification_issuing_authority_and_type || !this.form.form_data.section_c.buyer_identification_type_code || !this.form.form_data.section_c.buyer_identification_number) {
                validateMessage = 'Section C 26.a. must be completed'
            }

            // If initial response date, NICS number or initial response are not present, NICS not required must be checked
            if (!validateMessage && !this.form.form_data.section_c.nics_initial_response_date || !this.form.form_data.section_c.nics_initial_response) { // (!this.form.nics_number ||
                if (!this.form.form_data.section_c.nics_buyer_background_check && !this.form.form_data.section_c.nics_buyer_exempt) {
                    validateMessage = 'If Section C 27.a., 27.b. or 27.c. are empty, then Section C 28. or 29. must be checked.'
                }
            }

            // If initial response date is not today, and NICS not required is not checked, recertification info must be present
            if (!validateMessage) {
                // get today's date
                let today = new Date()
                let dd = String(today.getDate()).padStart(2, '0')
                let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
                let yyyy = today.getFullYear()
                let currentDate = yyyy + '-' + mm + '-' + dd
                if (this.form.form_data.section_c.nics_initial_response_date != currentDate && !this.form.form_data.section_c.nics_buyer_background_check && !this.form.form_data.section_c.nics_buyer_exempt) {
                    if (!this.form.form_data.section_d.buyer_recertification_signature && !this.form.form_data.section_d.buyer_recertification_date) {
                        validateMessage = "If Section C 27.a. is not today's date, and Section C 28. or 29. are not checked, then Section D 30. and 31. must be completed."
                    }
                }
            }

            // TODO: what does Andrew say about if Not Transferred is checked?
            // if (validateMessage) {
            //     // alert(validateMessage)
            //     this.sectionESignatureMessage = validateMessage
            //     return
            // }

            if (this.signaturePadOnScreen) this.signaturePad.clear()
            this.signaturePadOnScreen = onScreen
            this.savedSignature = this.form.form_data.section_e.seller_signature
        	this.form.form_data.section_e.seller_signature = null
        	setTimeout(() => {
        		this.initializeSignaturePad('seller_signature_pad')
        	}, 500)
        },
		cropCanvasImage(ctx) {
			var canvas = ctx.canvas, 
				w = canvas.width, h = canvas.height,
				pix = {x:[], y:[]},
				imageData = ctx.getImageData(0,0,canvas.width,canvas.height),
				x, y, index;
			for (y = 0; y < h; y++) {
				for (x = 0; x < w; x++) {
				index = (y * w + x) * 4;
				if (imageData.data[index+3] > 0) {
					pix.x.push(x);
					pix.y.push(y);
				} 
				}
			}
			pix.x.sort(function(a,b){return a-b});
			pix.y.sort(function(a,b){return a-b});
			var n = pix.x.length-1;
			w = 1 + pix.x[n] - pix.x[0];
			h = 1 + pix.y[n] - pix.y[0];
			var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);
			canvas.width = w;
			canvas.height = h;
			ctx.putImageData(cut, 0, 0);
		},
        cancelSellerSignature() {
            this.capturingSignature = false
            this.savedSignature = this.form.form_data.section_e.seller_signature
        	this.form.form_data.section_e.seller_signature = null
        	setTimeout(() => {
        		this.initializeSignaturePad('seller_signature_pad')
        	}, 500)
        },
        restoreSellersSignature() {
            this.capturingSignature = false
            this.form.form_data.section_e.seller_signature = this.savedSignature
        },
        initializeSignaturePad(id) {
            console.log('initializeSignaturePad', this.signaturePadOnScreen);
            if (this.signaturePadOnScreen) {
				let canvas = document.getElementById(id);
				this.signaturePad = new SignaturePad(canvas, { minWidth: 2, maxWidth: 2 })
			} else {
                //Get the canvas element from the document.
                this.signaturePad = document.getElementById(id);

                //Create a new ScriptelEasyScript handler
                this.scriptel = new ScriptelEasyScript();

                //If we're using international keyboard support this callback
                //looks for the starting character as typed by different keyboards
                //in an attempt to automatically detect which keyboard we're using.
                //
                //This is only provided as an example, depending on your use
                //case something more robust will probably be required.
                //
                //Note: This is only for non-streaming, non-compressed EasyScript
                //devices, in these modes this is handled automatically.
                this.scriptel.configurationCallback = (evt,chr) => {
                    if(chr==='"') {
                        this.scriptel.fromKeyboardSpec = "ca-fr";
                    } else {
                        this.scriptel.fromKeyboardSpec = "us-basic";
                    }
                };

                //Adds a signature listener to the document that will automatically catch
                //any signatures "typed" within the document body.
                //
                //WARNING!!!!!
                //If you are creating pop-up window (modal) and
                //are registering the listener to document make sure you
                //call removeSignatureListener when the modal is
                //destroyed otherwise the library will continue listening.
                this.scriptel.addSignatureListener(document);

                //Adds a streaming callback to the EasyScript library,
                //this gets notified when events happen.
                this.scriptel.registerStreamingCallback((e) => {
                    switch (e.type) {
                        case "ScriptelSignatureMetaData":
                            this.clearCanvas();
                            break;
                        case "ScriptelNewStroke":
                            this.prevPoint = null;
                            break;
                        case "ScriptelCoordinate":
                            if (this.prevPoint != null) {
                                this.scriptel.drawSegmentOnCanvas(this.prevPoint, e, this.signaturePad,{"strokeStyle":"black","lineWidth":2});
                            }
                            this.prevPoint = e;
                            break;
                        case "ScriptelCancelSignature":
                            this.clearCanvas();
                            this.prevPoint = null;
                            break;
                        case "ScriptelSignatureComplete":
                            switch(this.signaturePad.id) {
                                case 'buyers_signature_pad':
                                    this.saveBuyersSignature();
                                    break;
                                case 'buyers_recertification_signature_pad':
                                    this.saveBuyersRecertificationSignature();
                                    break;
                                case 'seller_signature_pad':
                                    this.saveSellerSignature()
                                    break;
                            }
                            break;
                    }
                })
            }
            this.clearCanvas()
		},
        saveBuyersSignature() {
            this.capturingSignature = false
	        this.form.form_data.section_b.signature = this.signaturePad.toDataURL()
	        this.prevPoint = null
		},
        saveBuyersRecertificationSignature() {
            this.capturingSignature = false
            this.form.form_data.section_d.buyer_recertification_signature = this.signaturePad.toDataURL()
            this.prevPoint = null
        },
		saveSellerSignature() {
            this.capturingSignature = false
            // if (this.signaturePadOnScreen) { this.signaturePad.removeBlanks() }
            this.cropCanvasImage(document.getElementById("seller_signature_pad").getContext("2d"))
	        this.form.form_data.section_e.seller_signature = this.signaturePad.toDataURL()
            if (this.signaturePadOnScreen) {
                this.signaturePad.off()
                this.signaturePad = null
            }
            this.signaturePadOnScreen = false
	        this.prevPoint = null
		},
		clearCanvas() {
            if (this.signaturePadOnScreen) {
				this.signaturePad.clear()
			} else {
				//Get the graphics context of the canvas.
				var ctx = this.signaturePad.getContext("2d");
                //Set the fill
                ctx.fillStyle = "transparent";
				//Clear the canvas and fill with the background color:
				ctx.clearRect(0,0,this.signaturePad.width,this.signaturePad.height);
			}
        },
        toggleNotTransferred() {
			this.form.form_data.section_e.not_transferred = !this.form.form_data.section_e.not_transferred
			if (this.form.form_data.section_e.not_transferred) {
				this.form.form_data.section_e.transfer_date = ''
				//this.form.form_data.section_a.total_firearms_transferred = "zero"
			} else {
                this.form.form_data.section_e.transfer_date = this.$moment().format('YYYY-MM-DD')
				this.checkFirearmsList()
			}
		},
        cancelForm() {
			this.apiCall({ destination: 'save_4473_inactive', data: { ffl_log_book_form_id: this.id, current_inactive: this.form.inactive } }).then((obj) => {
                this.$router.push('/logbooks/4473')
			}).catch((err) => {
				console.log(err)
			})
        },
        markFormForCorrection() {
            this.sectionBCorrectionDialog = false
            this.sectionDCorrectionDialog = false
			this.apiCall({ destination: 'save_4473_internal_use_only', data: { ffl_log_book_form_id: this.id, current_internal_use_only: this.form.internal_use_only } }).then((obj) => {
                if (this.form.internal_use_only) {
                    this.fetchData()
                } else {
                    this.$router.push({ path: '/logbooks/customer-4473', query: { section: this.sectionLetter.toLowerCase(), id: this.id }})
                }
			}).catch((err) => {
				console.log(err)
			})
        },
        filesUploadSuccess(file, response) {
            var obj = JSON.parse(response)
            let data = {
                ffl_log_book_form_id: this.id,
                file_name: obj.file_name,
                file_type: obj.file_type
            }
            this.apiCall({ destination: 'save_log_book_form_attachments', data: data }).then(obj => {
                if (obj.status != 'success') {
                    this.uploadMessage = obj.message
                } else {
                    this.getLogBookFormAttachments()
                    this.uploadMessage = 'Attachment saved!'
                }
            })
        },
        filesUploadError(file, message, xhr) {
			console.log('filesUploadError')
			console.log(file)
			console.log(message)
            this.uploadMessage = message
			console.log(xhr)
		},
        filesFileAdded(file) {
            this.savingForm = true
            this.filesAdded++
        },
        removeFile() {
            let removeFile = this.fileReference[this.confirmFileRemove]
            this.apiCall({ destination: 'save_log_book_form_attachments', data: { ffl_log_book_form_id: this.id, file_name: removeFile.file_name, delete: true } }).then(obj => {
                if (obj.status == 'success') {
                    this.getLogBookFormAttachments()
                    this.uploadMessage = 'Attachment removed!'
                    this.confirmFileRemove = null
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../detail-4473.scss";
</style>
